{
    "10th_day": "10th Day",
    "11th_day": "11th Day",
    "12th_day": "12th Day",
    "13th_day": "13th Day",
    "14th_day": "14th Day",
    "15th_day": "15th Day",
    "16th_day": "16th Day",
    "17th_day": "17th Day",
    "18th_day": "18th Day",
    "19th_day": "19th Day",
    "1st_day": "1st Day",
    "20th_day": "20th Day",
    "21st_day": "21st Day",
    "22nd_day": "22nd Day",
    "23rd_day": "23rd Day",
    "24th_day": "24th Day",
    "25th_day": "25th Day",
    "26th_day": "26th Day",
    "27th_day": "27th Day",
    "28th_day": "28th Day",
    "29th_day": "29th Day",
    "2nd_day": "2nd Day",
    "30th_day": "30th Day",
    "31st_day": "31st Day",
    "3rd_day": "3rd Day",
    "4th_day": "4th Day",
    "5th_day": "5th Day",
    "6th_day": "6th Day",
    "7th_day": "7th Day",
    "8th_day": "8th Day",
    "9th_day": "9th Day",
    "a_friendly_name_to_refer_to_later": "A Friendly Name to refer to later",
    "a_migration_flag_was_found_in_this_item": "A migration flag was found in this item",
    "a_user_with_that_username_already_exists,_please_ensure_username_is_unique": "A user with that Username already exists, Please ensure Username is unique",
    "aborted": "Aborted",
    "academic_hold": "Academic Hold",
    "academic_hold_header": "The Academic hold page allows you to place a hold on a student's account. This will prevent any courses they are enrolled in from being removed by any retention policies. Additional details on the User Data Management feature can be found in the",
    "academic_hold_instructions_link": "User Data Management help desk article",
    "academic_standing": "academic standing",
    "access_token": "Access Token",
    "access_token_10": "Access Token 10",
    "access_token_11": "Access Token 11",
    "access_token_12": "Access Token 12",
    "access_token_13": "Access Token 13",
    "access_token_14": "Access Token 14",
    "access_token_15": "Access Token 15",
    "access_token_16": "Access Token 16",
    "access_token_17": "Access Token 17",
    "access_token_18": "Access Token 18",
    "access_token_19": "Access Token 19",
    "access_token_2": "Access Token 2",
    "access_token_20": "Access Token 20",
    "access_token_3": "Access Token 3",
    "access_token_4": "Access Token 4",
    "access_token_5": "Access Token 5",
    "access_token_6": "Access Token 6",
    "access_token_7": "Access Token 7",
    "access_token_8": "Access Token 8",
    "access_token_9": "Access Token 9",
    "access_tokens_creation_type": "Access Tokens Creation Type",
    "account_notifications": "Account Notifications",
    "account_notifications_description": "Account Notifications are required for password recovery and resets",
    "account_permissions": "Account Permissions",
    "account_policies": "Account Policies",
    "accounts": "Accounts",
    "achieve_mastery": "achieve mastery",
    "acount": "Account",
    "action": "Action",
    "action_required": "Action Required",
    "active": "Active",
    "active_learning_management_systems": "Active Learning Management Systems",
    "adaptive_release_rules": "adaptive release rules",
    "add": "Add",
    "add_academic_hold": "Add Academic Hold",
    "add_component": "Add Component",
    "add_custom_parameter": "Add Custom Parameter",
    "add_grade_scale": "Add Grade Scale",
    "add_import_pattern": "Add Import Pattern",
    "add_key": "Add Key",
    "add_location": "Add Location",
    "add_multiple_module_titles": "Add Multiple Module Titles",
    "add_new_user": "Add New User",
    "add_ratings": "Add Ratings",
    "add_suffix_to_module_descriptions": "Add Suffix to Module Descriptions",
    "add_term": "Add Term",
    "add_users": "Add Users",
    "add_users_to_course": "Add Users to Course",
    "additional_information_about_soc_2_reports_can_be_found_at": "Additional information about SOC 2 reports can be found at:",
    "address": "address",
    "address_type": "Address Type",
    "admin": "Admin",
    "admin_settings": "Admin Settings",
    "admin_settings_optional": "*To access integration details from the Admin page, Admin Settings permission  must be enabled.",
    "admin_settings_optional_archivev2": "*To access integration details on the Admin and Import page and initiate an import, Admin Settings permission must be enabled.",
    "admin_settings_permission": "Grants users access to the Admin page, where users can manage Password Policies, Password Refresh settings, New User Email Templates, and Institution Styling.",
    "admin_settings_permission_archivev2": "Grants users access to the Admin page, where users can manage Password Policies, Password Refresh settings, New User Email Templates, and Institution Styling, as well as provides access to the Import page.",
    "admin_settings_required": "*Requires Admin Settings permission.",
    "admin_view_integrations_required": "*Requires Admin Settings and View Integrations permission.",
    "admin_view_sso_required": "*Requires Admin Settings and View SSO permissions.",
    "advanced_options": "Advanced Options",
    "age": "age",
    "age_import_instructions": "The Automatic Importer will run on the 15th of each month and check for courses that meet the requirements provided below. Once a course meets the requirements, they will automatically be imported into your archiving instance.",
    "ai_classification": "AI Classification",
    "ai_confidence": "AI Confidence",
    "ai_detection": "AI Detection",
    "ai_only": "AI Only",
    "ai_probability": "AI Probability",
    "ai_probability_report": "AI Probability Report",
    "ai_probability_review": "AI Probability Review",
    "ai-detection": "AI Detection",
    "ai-detection-report": "AI Detection Report",
    "alarm": "Alarm",
    "alert_type": "Alert Type",
    "alerts": "Alerts",
    "alerts_enabled": "Scaffold Alerts",
    "alerts_enabled_description": "Alert Notifications are used for issues that have an impact on the Scaffold instance",
    "aligned_goals": "Aligned Goals",
    "alignment": "Alignment",
    "all": "All",
    "all_courses": "All Courses",
    "all_courses_that_are_currently_being_processed_or_in_queue_will_be_aborted_permanently": "All courses that are currently being processed or in queue will be aborted permanently",
    "all_courses_that_are_currently_being_processed_or_in_queue_will_be_aborted.": "All courses that are currently being processed or in queue will be aborted.",
    "all_entities": "All Entities",
    "all_images_set_to_view_and_download": "All images set to view and download",
    "all_submissions": "Display All Submissions",
    "allow_liking": "Allow Liking",
    "amount_of_tokens_to_auto_generate": "Amount of Tokens to Auto Generate",
    "an_email_address_is_required": "An email address is required",
    "an_error_occured_during_the_copy": "An error occured during the copy",
    "an_unknown_error_has_occurring_while_getting_authorized": "An unknown error has occurring while getting authorized",
    "analytics": "Analytics",
    "anayltics": "Anayltics",
    "and": "And",
    "announcement_details": "Announcement Details",
    "announcement_title": "ANNOUNCEMENT TITLE",
    "announcements": "Announcements",
    "answer": "Answer",
    "answer_choice_for": "Answer Choice for ",
    "answer_choices": "Answer Choices",
    "answer_for": "answer for",
    "answer_formula": "Answer Formula",
    "answer_in_the_range_between": "Answer in the Range between",
    "answer_range": "Answer Range",
    "answer_type": "answer type",
    "answer_with_precision": "Answer with Precision",
    "answers": "Answers",
    "any": "any",
    "app_id": "App ID",
    "app_key": "App Key",
    "append_course_title": "Append Course Title",
    "append_course_title_text_as": "Append Course Title Text As",
    "april": "April",
    "archive": "archive",
    "archive_users": "Archive Users",
    "archiveusers": "Archive Users",
    "archiving_set_up_wizard": "Archiving Set Up Wizard",
    "are_you_sure_you_want_to_cancel_lingo": "Are you sure you want to cancel? You will lose all unsaved progress made on this page.",
    "are_you_sure_you_want_to_cancel_this_import": "Are you sure you want to cancel this import",
    "are_you_sure_you_want_to_cancel_this_migration": "Are you sure you want to cancel this migration",
    "are_you_sure_you_want_to_close_with_unsaved_work": "Are you sure you want to close with unsaved work?",
    "are_you_sure_you_want_to_close_with_unsaved_work_wizard_lingo": "Are you sure you want to close with unsaved work? Each time you access Scaffold, you will be directed to complete the Wizard until each step has been completed.",
    "are_you_sure_you_want_to_delete": "Are you sure you want to delete",
    "are_you_sure_you_want_to_delete_this_item": "Are you sure you want to delete this item",
    "are_you_sure_you_want_to_delete_this_schedule": "Are you sure you want to delete this schedule",
    "are_you_sure_you_want_to_delete_this_snapshot": "Are you sure you want to delete this snapshot",
    "are_you_sure_you_want_to_deploy_this_staged_version": "Are you sure you want to deploy this staged version",
    "are_you_sure_you_want_to_disable": "Are you sure you want to disable",
    "are_you_sure_you_want_to_enable": "Are you sure you want to enable",
    "are_you_sure_you_want_to_publish_and_deploy_this_version": "Are you sure you want to publish and deploy this version",
    "are_you_sure_you_want_to_publish_this_version": "Are you sure you want to publish this version",
    "are_you_sure_you_want_to_stage_a_restored_version_of": "Are you sure you want to stage a restored version of",
    "are_you_sure_you_want_to_stage_version": "Are you sure you want to stage version",
    "are_you_sure_you_want_to_zip": "Are you sure you want to zip",
    "area_code": "Area Code",
    "assignment": "assignment",
    "assignment_settings": "Assignment Settings",
    "assignment_title": "Assignment Title",
    "assignmentgroups": "Assignment Groups",
    "assignments": "Assignments",
    "assignmentsubmissions": "Assignment Submissions",
    "associated_courses": "Associated Courses",
    "asynchronous_course_elements": "Asynchronous Course Elements",
    "at": "At",
    "at_this_time._please_try_again_later._if_the_problem_persists_please_contact_an_administrator.": "at this time. Please try again later. If the problem persists please contact an administrator.",
    "attempt_to_restore_course_deleted_in_lms": "Attempt to restore course deleted in LMS",
    "attempted": "attempted",
    "attempting_to_create": "Attempting to Create",
    "attempting_to_create_duplicated_integration": "Attempting to create duplicated integration",
    "attempting_to_update": "Attempting to Update",
    "attempts": "Attempts",
    "audience_uri": "Audience URI",
    "august": "August",
    "authentication_app": "Authentication App",
    "authentication_protocol": "Authentication Protocol",
    "authenticator_app": "Authenticator App",
    "author": "Author",
    "authorization_url_where_the_user_will_be_redirected_to_authenticate": "Authorization URL where the user will be redirected to authenticate",
    "authorized_integrations": "Authorized Integrations",
    "authorized_integrations_definition": "Limits the users access to authorized integrations only. Authorized integrations are assigned in the User's Account details.",
    "auto_fill_through_issuer_url": "Auto fill through Issuer URL",
    "auto_import": "Automatic Import",
    "auto_import_by_end_date": "Automatic Import by End Date",
    "auto_import_terms": "Auto Import Terms",
    "auto_import_terms_tooltip": "This will import courses from the selected terms periodically to be added or updated",
    "autosave": "Auto Save",
    "availability": "Availability",
    "available": "Available",
    "available_integrations": "Available Integrations",
    "averange": "average",
    "awaiting_credentials": "Awaiting Credentials",
    "awaiting_system_configuration": "Awaiting System Configuration",
    "back": "Back",
    "batch_date": "Batch Date",
    "batch_type": "Batch Type",
    "binary_format": "Binary Format",
    "blueprint": "Blueprint",
    "blueprint_and_data_model_management": "Blueprint and Data Model Management",
    "blueprint_data_model_definition": "Grants users the ability to create and edit Blueprints, as well as permission to update to the latest versions of K16-provided Blueprints and Data Models.",
    "blueprint_name": "Blueprint Name",
    "blueprint_version": "Blueprint Version",
    "blueprints_are_designs_that_extend_or_combine_the_scaffold_transformations_to_develop_integrated_datasets_across_applications": "Blueprints are designs that extend or combine the Scaffold Transformations to develop integrated datasets across applications",
    "body": "Body",
    "both": "Both",
    "both_the_integration_and_the_import_must_be_unpaused_for_it_to_resume.": "Both the integration and the import must be unpaused for it to resume.",
    "both_the_integration_and_the_migration_must_be_unpaused_for_it_to_resume.": "Both the integration and the migration must be unpaused for it to resume.",
    "breaking_update": "Breaking Update",
    "browse": "Browse",
    "builder": "Builder",
    "business_glossary": "Business Glossary",
    "business_glossary_definition": "Grants users the access to create and manage Business Glossary terms.",
    "business_glossary_management": "Business Glossary Management",
    "business_glossary_permission_definition": "Grants users the access to create and manage Business Glossary terms.",
    "business_glossary_reference": "Business Glossary Reference",
    "business_glossary_reference(s)": "Business Glossary Reference(s)",
    "business_glossary_source(s)": "Business Glossary Source(s)",
    "button_example": "Button Example",
    "button_text": "Button Text",
    "button_text_color": "Button Text Color",
    "button_text_color_description": "This controls text color across all buttons",
    "by_course_end_date": "By Course End Date",
    "by_course_id": "By Course ID",
    "by_course_search": "By Course Search",
    "by_csv_upload": "By CSV Upload",
    "by_terms": "By Terms",
    "callback_url": "Callback URL",
    "can_manage_users": "Manage Users",
    "can_only_edit_customer_blueprints": "Can only Edit Customer Blueprints",
    "cancel": "Cancel",
    "cancel_changes": "Cancel Changes",
    "cancel_import": "Cancel Import",
    "cancel_migration": "Cancel Migration",
    "cancel_move": "Cancel Move",
    "canceled_staged_version": "Canceled Staged Version",
    "cannot_be_an_email": "Cannot be an email",
    "cannot_place_workbook_at_the_root_level": "Cannot place workbook at the root level",
    "cant_be_used_in_combination_with_single_file_or_overwrite_options": "Create files per unique value for selected fields. Cant be used in combination with single file or overwrite options",
    "card": "Card",
    "catalog": "Catalog",
    "categorization": "Categorization",
    "category": "Category",
    "category_icon": "Category Icon",
    "category_icon_update": "Update Category Icons",
    "category_new": "New Category",
    "category_to_update": "Category to Update",
    "change_log": "Change Log",
    "changes": "Changes",
    "character_encoding_format_of_your_file_(e.g.,_utf-8,_ascii)._choose_utf-8_for_international_characters": "Character encoding format of your file (e.g., UTF-8, ASCII). Choose UTF-8 for international characters",
    "character_that_separates_data_fields_in_your_csv_file_(e.g.,_comma,_tab,_semicolon)": "Character that separates data fields in your CSV file (e.g., comma, tab, semicolon)",
    "character_that_separates_records_in_your_csv_file": "Character that separates records in your csv file",
    "character_that_surrounds_field_values": "Character that surrounds field values",
    "character_that_surrounds_field_values_(usually_quotes)_to_handle_special_characters": "Character that surrounds field values (usually quotes) to handle special characters",
    "character_used_to_escape_special_characters": "Character used to escape special characters",
    "character_used_to_escape_unenclosed_fields": "Character used to escape unenclosed fields",
    "child_course_id": "Child Course ID",
    "children_learning_modules_as_folders": "Children Learning Modules as Folders",
    "choose_file": "Choose File",
    "citizen": "Citizen",
    "class": "class",
    "clear_file": "Clear File",
    "clear_search": "Clear Search",
    "click_new_import_to_get_started": "Click New Import to get started",
    "click_new_migration_to_get_started": "Click New Migration to get started",
    "click_to_edit": "Click to edit",
    "click_to_insert_into_editor": "Click to Insert Into Editor",
    "click_to_manage_links": "Click to manage links",
    "client_id": "Client ID",
    "client_id_provided_by_your_identity_provider": "Client ID provided by your identity provider",
    "client_secret": "Client Secret",
    "client_secret_provided_by_your_identity_provider": "Client Secret provided by your identity provider",
    "client_tenant": "Client Tenant",
    "close": "Close",
    "close_enough": "close enough",
    "close_module": "Close Module",
    "college": "college",
    "color_styles_explanation": "Here is what the color styling will look like applied to buttons and links. To make changes, adjust the colors in the section above",
    "colors": "Colors",
    "column": "Column",
    "column_name": "Column Name",
    "column_name_cannot_exceed_255_characters": "Column name cannot exceed 255 characters",
    "column_name_is_required": "Column name is required",
    "column_name_must_contain_only_letters,_numbers,_underscores,_and_dollar_signs": "Column name must contain only letters, numbers, underscores, and dollar signs",
    "column_name_must_start_with_a_lette_or_underscore": "Column name must start with a letter (A-Z, a-z) or an underscore ('_')",
    "columns": "Columns",
    "columns_that_could_not_be_updated_are_listed_below_with_errors_and_will_need_to_be_updated_manually_with_a_new_csv_file.": "Columns that could not be updated are listed below with errors and will need to be updated manually with a new csv file.",
    "combined_academic_standing": "combined academic standing",
    "comment": "Comment",
    "comment_new": "New Comment",
    "comment_selection": "Comment Selection",
    "comments": "Comments",
    "communication_settings": "Communication Settings",
    "compare_&_update": "Compare & Update",
    "competencies_skills": "Competencies / Skills",
    "complete": "Complete",
    "complete_only_one_csv_column_course_id_section_id_or_sis_section_id": "Complete Only One Column per Row in The Template \"Course Id\", \"Section Id\" or \"Sis Section Id\"",
    "completed": "completed",
    "compression": "Compression",
    "configuration_get": "Get Configuration",
    "configuration_overrides": "Configuration Overrides - Use only if needed",
    "configuration_process": "Process Configuration",
    "configuration_updates": "Configuration Updates",
    "configuration_url": "Configuration URL",
    "configure": "Configure",
    "confirm": "Confirm",
    "constraints": "Constraints",
    "consumer_key": "Consumer Key",
    "contact_information": "contact information",
    "content_invalid": "The content of this field is invalid!",
    "continue": "Continue",
    "continue_editing": "Continue Editing",
    "convert_blogs_to_assignments": "Convert Blogs to Assignments",
    "convert_blogs_to_discussions": "Convert Blogs to Discussions",
    "convert_embedded_html_to_pages": "Convert Embedded HTML to Pages",
    "convert_empty_field_values_to_null_instead_of_empty_strings_in_the_database": "Convert empty field values to NULL instead of empty strings in the database",
    "convert_label_tabs_to_pages": "Convert Label Tabs to Pages",
    "convert_syllabus": "Convert Syllabus",
    "convert_youtube_links_to_embedded_youtube_videos": "Convert Youtube Links to Embedded Youtube Videos",
    "copied": "Copied",
    "copy": "Copy",
    "copy_blueprint": "Copy Blueprint",
    "copy_existing_module": "Copy Existing Module",
    "copy_finished": "Copy Finished",
    "copy_sql": "Copy SQL",
    "copy_started_from": "Copy Started from",
    "copy_to_clipboard": "Copy to Clipboard",
    "copy_url": "Copy URL",
    "correct_answer": "Correct Answer",
    "correct_answer_selection_for": "Correct Answer Selection for ",
    "correct_feedback": "Correct Feedback",
    "country_code": "Country Code",
    "course": "Course",
    "course_academic_hold": "Course Academic Hold",
    "course_access_enroll_definition": "In order to access a course, users must be enrolled in the course.",
    "course_access_requires_enrollment": "Course Access Requires Enrollment",
    "course_code": "Course Code",
    "course_copy_to_new": "Copy to New Course",
    "course_count": "Course Count",
    "course_description": "Course Description",
    "course_details": "Course Details",
    "course_end_date": "Course End Date",
    "course_end_date_details": "Course End Date Details",
    "course_end_date_older_than": "Automatically import courses with an end date older than",
    "course_exists": "Course Exists",
    "course_file_storage": "Course File Storage",
    "course_id": "Course ID",
    "course_id_scaffold": "Scaffold Course ID",
    "course_import": "Course Import",
    "course_imports": "Course Imports",
    "course_information": "Course Information",
    "course_search": "Course Search",
    "course_sections": "course sections",
    "course_state": "Course State",
    "course_template_id": "Course Template ID",
    "course_title": "Course Title",
    "courses": "Courses",
    "courses_to_import": "Courses to Import",
    "coursesections": "Course Sections",
    "create": "Create",
    "create_a_module_for_unlinked_assignments": "Create a Module for Unlinked Assignments",
    "create_a_module_for_unlinked_quizzes": "Create a Module for Unlinked Quizzes",
    "create_accounts": "Create Accounts",
    "create_export": "Create Export",
    "create_folder": "Create Folder",
    "create_identity_provider": "Create Identity Provider",
    "create_integration": "Create Integration",
    "create_new": "Create New",
    "create_new_lti": "Create New LTI",
    "create_retention_rule": "Create Retention Rule",
    "create_snapshot": "Create Snapshot",
    "create_workbook": "create_workbook",
    "create_worksheet": "Create Worksheet",
    "created": "Created",
    "created_by": "Created By",
    "created_integration_getting_tokens_and_terms_lingo": "Created Integration. Getting Tokens and Terms",
    "created_schedule": "Created Schedule",
    "credit_hours": "credit hours",
    "criteria": "Criteria",
    "critical": "Critical",
    "crm_type": "CRM Type",
    "crn": "crn",
    "csv_column": "CSV Column",
    "csv_upload": "CSV Upload",
    "current_live_version": "Current Live Version",
    "current_live_version_that_is_deployed": "Current Live Version That is Deployed",
    "current_role": "Current Role",
    "current_status_of_the_course": "Current status of the course",
    "current_uploaded_files_to_be_scanned_and_used_for_your_data": "Current uploaded files to be scanned and used for your data",
    "currently_disabled_blueprint": "Currently Disabled Blueprint",
    "currently_enabled_blueprint": "Currently Enabled Blueprint",
    "currently_logged_out": "You are currently logged out",
    "currently_scaled_to": "Currently Scaled to",
    "curricula_term": "Curricula Term",
    "custom_parameters": "Custom Parameters",
    "customer_blueprint": "Customer Blueprint",
    "customer_blueprints_are_custom_designs_that_extend_or_combine_the_scaffold_transformations_to_develop_integrated_datasets_across_applications": "Customer Blueprints are custom designs that extend or combine the Scaffold Transformations to develop integrated datasets across applications",
    "daily": "Daily",
    "dark_theme": "Dark Theme",
    "dashboard": "Dashboard",
    "data": "Data",
    "data_connections": "Data Connections",
    "data_export": "Data Export",
    "data_retention": "Data Retention",
    "data_retention_description": "Grants access to manage Data Retention rules for your institution.",
    "data_retention_rules": "Data Retention Rules",
    "data_type_new": "New Data Type",
    "data_type_update": "Update Data Type",
    "data-retention-header": "Use the Data Retention page to define institution-specific Retention Rules and manage academic holds on courses. For detailed instructions, please review the",
    "data-retention-instructions-link": "Data Retention help desk article",
    "date": "Date",
    "date_format": "Date Format",
    "date_of_birth": "Date of Birth",
    "date_submitted": "Date Submitted",
    "day": "Day",
    "day_occurrence": "Day Occurrence",
    "day_of_the_month": "Day of the Month",
    "days": "Days",
    "decaying_average": "decaying average",
    "december": "December",
    "decimal_places": "Decimal Places",
    "decimals": "decimals",
    "default": "Default",
    "defer_till_this_date": "Defer till this Date",
    "defined_by": "Defined By",
    "definition": "Definition",
    "degree": "Degree",
    "delete": "Delete",
    "delete_blueprint": "Delete Blueprint",
    "delete_integration": "Delete Integration",
    "delete_item": "Delete Item",
    "delete_schedule": "Delete Schedule",
    "delete_selected": "Delete Selected",
    "delete_snapshot": "Delete Snapshot",
    "delete_snapshots": "Delete Snapshots",
    "delete_worksheet": "Delete Worksheet",
    "deleted_integration": "Deleted Integration",
    "deleting": "Deleting",
    "deleting_this_will_affect_these_downstream_entities": "Deleting this will affect these downstream entities",
    "department": "department",
    "deploy": "Deploy",
    "deploy_imported_entity": "Deploy Imported Entity",
    "deploy_later": "Deploy Later",
    "deploy_or_edit": "Deploy or Edit",
    "deploy_staged_version": "Deploy Staged Version",
    "deploy_update": "Deploy Update",
    "deployed": "Deployed",
    "deployed_on": "Deployed on",
    "deploying": "Deploying",
    "deployments": "Deployments",
    "description": "Description",
    "destination": "Destination",
    "destination_integrations": "Destination Integrations",
    "destination_lms_type": "Destination LMS Type",
    "details": "Details",
    "details_&_descriptions": "Details & Descriptions",
    "development_status": "Development Status",
    "direct_downstream": "Direct Downstream",
    "direct_upstream": "Direct Upstream",
    "disabled": "Disabled",
    "disable": "Disable",
    "disable_auth_imports": "To disable View Integrations, the permissions Authorized Integrations and Manage Imports must be disabled.",
    "disable_auth_integration": "To disable View Integrations, the permission Authorized Integrations must be disabled.",
    "disable_blueprint": "Disable Blueprint",
    "disable_business_glossary": "Disable Business Glossary",
    "disable_feature": "Disable Features",
    "disable_features_description": "Prevents users from accessing specific features",
    "disable_integration_imports": "To disable View Integrations, the permission Manage Imports must be disabled.",
    "disable_integrations_auth": "To disable View Integrations, the permissions Authorized Integrations and Manage Integrations must be disabled.",
    "disable_integrations_auth_imports": "To disable View Integrations, the permissions Authorized Integrations, Manage Integrations, and Manage Imports must be disabled.",
    "disable_integrations_manage": "To disable View integrations, the permission Manage Integrations must be disabled.",
    "disable_integrations_manage_imports": "To disable View Integrations, the permissions Manage Integrations and Manage Imports must be disabled.",
    "disable_manage_imports": "To disable Admin Settings, the permission Manage Imports must be disabled.",
    "disable_manage_integration": "To disable Admin Settings, the permissions Manage Integrations must be disabled.",
    "disable_manage_integration_imports": "To disable Admin Settings, the permissions Manage Integrations and Manage Imports must be disabled.",
    "disable_manage_reports": "To disable View Reports, the permission Manage Reports must be disabled.",
    "disable_manage_roles": "To disable Manage Users, the permission Manage Roles must be disabled.",
    "disable_manage_sso": "To disable View SSO, the permission Manage SSO must be disabled.",
    "disable_restore": "Disable Restore",
    "disable_restore_definition": "Prevents users from restoring soft deleted courses in the LMS.",
    "disable_syncing": "Disable Syncing",
    "disable_view_sso": "To disable Admin Settings, the permission View SSO must be disabled.",
    "disable_view_sso_imports": "To disable Admin Settings, the permissions View SSO and Manage Imports must be disabled.",
    "disable_view_sso_manage_integrations": "To disable Admin Settings, the permissions View SSO and Manage Integrations must be disabled.",
    "disable_view_sso_manage_integrations_imports": "To disable Admin Settings, the permisssions View SSO, Manage Integrations, and Manage Imports must be disabled.",
    "disabled_syncing_definition": "Prevents users from syncing courses to the LMS.",
    "disabled_until_integration_is_ready": "Disabled Until Integration is Ready",
    "discard": "Discard",
    "discard_announcements": "Discard Announcements",
    "discard_duplicate_rubrics": "Discard duplicate Rubrics",
    "discard_empty_folders": "Discard Empty Folders",
    "discard_empty_modules": "Discard Empty Modules",
    "discard_staged_version": "Discard Staged Version",
    "discard_unused_files_and_folders": "Discard Unused Files And Folders",
    "discard_unused_quizzes": "Discard Unused Quizzes",
    "discussion": "Discussion",
    "discussion_posts": "Discussion Posts",
    "discussion_posts_by_student": "Discussion Posts by Student",
    "discussion_replies": "Discussion Replies",
    "discussion_settings": "Discussion Settings",
    "discussion_thread_as_instructions": "Discussion Thread as Instructions",
    "discussion_title": "Discussion Title",
    "discussionreplies": "Discussion Replies",
    "discussions": "Discussions",
    "display_on_web": "Display on Web",
    "distractors": "Distractors",
    "do_not_enable_any_identity_provider_here_until_you_have_done_so.": "Do not enable any identity provider here until you have done so.",
    "do_not_use_an_email_for_the_username_or_include_any_spaces": "Do not use an email for the username or include any spaces",
    "do_not_use_this_unless_you_are_absolutely_sure_you_have_a_reason_config_lingo": "Do not use this unless you are absolutely sure you have a reason. Select the source type if you need a configuration different from the root for this instance type.",
    "do_you_want_to_deploy_the_current_staged_version_before_editing": "Do you want to deploy the current staged verion before editing",
    "do_you_want_to_verify_this_email_now": "Do you want to verify this email now",
    "document": "Document",
    "documentation": "Documentation",
    "documents": "Documents",
    "domain": "Domain",
    "done_uploading": "Done Uploading",
    "download": "Download",
    "download_complete": "Download Complete",
    "download_course_csv": "Download Course CSV",
    "download_csv": "Download CSV",
    "download_enrollments_csv": "Download Enrollments CSV",
    "download_failed": "Download Failed",
    "download_instructions": "Download Instructions",
    "download_template": "Download Template",
    "downloaded_csv": "Downloaded CSV",
    "downloaded_csv_template": "Downloaded CSV Template",
    "downloaded_public_signature_certificate": "Downloaded Public Signature Certificate",
    "downloading": "Downloading",
    "downloading_export": "Downloading export",
    "downloading_public_signature_certificate": "Downloading Public Signature Certificate",
    "downloading_zip": "Downloading Zip",
    "downstream": "Downstream",
    "draft": "Draft",
    "draft_only": "Draft Only",
    "drafted": "Drafted",
    "drag_and_drop_file": "Drag & Drop File",
    "dropdown": "dropdown",
    "due": "due",
    "due_date": "Due Date",
    "duplicate": "Duplicate",
    "duplicate_email": "Duplicate Email",
    "duplicate_integration": "Duplicate Integration",
    "duplicate_username": "Duplicate Username",
    "duplicated_integration": "Duplicated Integration",
    "earlier": "Earlier",
    "edit": "Edit",
    "edit_blueprint": "Edit Blueprint",
    "edit_draft": "Edit Draft",
    "edit_integration": "Edit Integration",
    "edit_integrations": "Manage Integrations",
    "edit_most_recent_draft": "Edit most recent draft",
    "edit_name": "Edit Name",
    "edit_schedule": "Edit Schedule",
    "edit_sso": "Manage SSO",
    "edit_theme": "Edit Theme",
    "edit_workbook": "Edit Workbook",
    "edit_worksheet": "Edit Worksheet",
    "editing": "Editing",
    "editing_will_cancel_this_version_update": "Editing will cancel this version update",
    "education": "education",
    "effective_date": "Effective Date",
    "either_overwrite_previous_files_exported_from_this_schedule_or_create_new_ones_with_each_occurrence": "Either overwrite previous files exported from this schedule or create new ones with each occurrence",
    "email": "Email",
    "email_mapping_attribute": "Email Mapping Attribute",
    "email_notifications_description": "Communications are sent to the email on your user account. These settings allow you to control what types of communications you receive.",
    "email_xml_mapping_attribute": "Email XML mapping attribute",
    "empty_folders_with_descriptions_to_pages": "Empty folders with descriptions to Pages",
    "enable": "Enable",
    "enable_admin_view_integrations": "Please enable Admin Settings and View Integrations first.",
    "enable_blueprint": "Enable Blueprint",
    "enable_business_glossary": "Enable Business Glossary",
    "enable_single_logout": "Enable Single Logout",
    "enable_view_integrations": "Please enable View Integrations first.",
    "enable_view_reports": "Please enable View Reports first.",
    "enable_view_sso": "Please enable View SSO first.",
    "enabled": "Enabled",
    "enabled_admin_settings": "Please enable Admin Settings first.",
    "enabled_manage_users": "Please enable Manage Users first.",
    "encrypt_keys": "Encrypt Keys",
    "end_date": "End Date",
    "end_date_import": "End Date Import",
    "end_session_with_identity_provider_when_logging_out_of_scaffold": "End Session with Identity Provider when logging out of Scaffold",
    "ended": "Ended",
    "enrolled_courses": "enrolled courses",
    "enrolled_users": "Enrolled Users",
    "enrollments": "Enrollments",
    "ensure_only_one_file_is_created_rather_than_potentially_creating_multiple_files_for_larger_exports": "Ensure only one file is created rather than potentially creating multiple files for larger exports",
    "ensure_the_user_email_value_is_mapped_to_the_attribute": "Ensure the user email value is mapped to the attribute",
    "enter": "Enter",
    "enter_a_mfa_code_to_complete_login": "Enter a MFA code to Complete Login that was sent to your Authenticator App",
    "entities": "Entities",
    "entities_that_have_been_created_from_the_import_process": "Entities that have been created from the import process",
    "entity": "Entity",
    "entity_already_has_active_schedules": "This entity already has active schedules",
    "entity_details": "Entity Details",
    "entity_must_be_enabled": "Entity must be enabled",
    "entity_must_be_published": "Entity must be published",
    "error": "Error",
    "error_applying_upgrade_for": "Error Applying Upgrade for",
    "error_attempting_to_validate": "Error Attempting to Validate",
    "error_canceling_staged_version": "Error Canceling Staged Version",
    "error_clearing_import": "Error Clearing Import",
    "error_clearing_migration": "Error Clearing Migration",
    "error_creating_folder": "Error Creating Folder",
    "error_creating_integration": "Error Creating Integration",
    "error_creating_version": "Error Creating Version",
    "error_creating_workbook": "Error Creating Workbook",
    "error_deleting": "Error Deleting",
    "error_deleting_integration_at_this_time": "Error Deleting Integration at this Time",
    "error_deleting_schedule": "Error Deleting Schedule",
    "error_deploying_import": "Error Deploying Import",
    "error_downloading_public_certificate": "Error Downloading Public Certificate",
    "error_duplicating_integration,_integration_friendly_name_must_be_unique": "Error Duplicating Integration, integration friendly name must be unique",
    "error_during_import": "Error During Import",
    "error_exporting_results": "Error Exporting Results",
    "error_finding_user_with_sso_user": "Error Finding User With SSO User",
    "error_gathering_terms_at_this_time": "Error Gathering Terms at this time",
    "error_getting_access_token": "Error Getting Access Token",
    "error_getting_authorization_code": "Error Getting Authorization Code",
    "error_getting_files": "Error Getting Files",
    "error_getting_imports": "Error Getting Imports",
    "error_getting_migrations": "Error Getting Migrations",
    "error_getting_results": "Error Getting Results",
    "error_getting_sigma_embedded_workbook": "Error Getting Sigma Embedded Workbook",
    "error_initiating_scan": "Error initiating scan",
    "error_loading": "Error Loading",
    "error_loading_additional_rows": "Error Loading Additional Rows",
    "error_loading_history": "Error Loading History",
    "error_loading_sigma": "Error Loading Sigma",
    "error_moving_item": "Error Moving Item",
    "error_refreshing_terms": "Error Refreshing Terms",
    "error_retrieving_ai_detection_report": "Error Retrieving AI Detection Report",
    "error_retrieving_full_entity_details": "Error Retrieving Full Entity Details",
    "error_retrieving_instructions": "Error Retrieving Instructions",
    "error_retrieving_integration": "Error Retrieving Integration",
    "error_retrieving_public_certificate": "Error Retrieving Public Certificate",
    "error_retrieving_sample_data": "Error Retrieving Sample Data",
    "error_retrieving_slack_channel_id": "Error Retrieving Slack Channel ID",
    "error_retrieving_snapshot_details": "Error retrieving snapshot details",
    "error_retrieving_versions": "Error Retrieving Versions",
    "error_saving": "Error Saving",
    "error_sending_message": "Error Sending Message",
    "error_sending_verification_code_at_this_time": "Error Sending Verification Code at this time",
    "error_setting_up_sigma": "Error Setting Up Sigma",
    "error_updating": "Error Updating",
    "error_updating_cogntio_domain._you_may_experience_issues_with_logging_in_with_sso._please_disable_all_identity_providers_at_this_time_as_a_precaution.": "Error Updating Cogntio Domain. You may experience issues with logging in with SSO. Please disable all identity providers at this time as a precaution",
    "error_updating_integration": "Error Updating Integration",
    "error_updating_integration_paused_state": "Error Updating Integration Paused State",
    "error_updating_password": "Error Updating Password",
    "error_updating_password_policy": "Error Updating Password Policy",
    "error_updating_schedule": "Error Updating Schedule",
    "error_updating_selected_terms_for_this_integration_wizard_lingo": "Error Updating selected terms for this integration:",
    "error_updating_theme_at_this_time.": "Error Updating Theme at this time.",
    "error_updating_user": "Error Updating User",
    "error_updating_worksheet_with_new_query": "Error updating worksheet with new query",
    "error_upgrading_entity": "Error Upgrading Entity",
    "error_validating_new_password": "Error Validating New Password",
    "error_while_uploading_csv": "Error while Uploading CSV",
    "error_with_code_provided._please_try_again": "Error with Code Provided. Please try again",
    "error_with_configuration": "Error with Configuration",
    "error_with_csv_file._make_sure_it_has_the_same_columns_as_the_template_and_has_at_least_one_valid_row": "Error with CSV file. Make sure it has the same columns as the template and has at least one valid row",
    "error_with_identity_provider": "Error With Identity Provider",
    "error_with_latest_scan": "Error with Latest Scan",
    "error_with_opening_tableau_dashboard_at_this_time": "Error with opening Tableau Dashboard at this time.",
    "error:_the_theme_has_been_not_been_updated_at_this_time": "Error: The Theme has been not been updated at this time",
    "errors_with_sample_rows": "Errors With Sample Rows",
    "escape_character": "Escape Character",
    "escape_unenclosed_field": "Escape Unenclosed Field",
    "essay": "Essay",
    "ethnicity": "Ethnicity",
    "every_month": "Every Month",
    "exact_answer": "Exact Answer",
    "example": "Example",
    "exceptionlog": "Exception Log",
    "exclude_html_tags": "Exclude HTML Tags",
    "excluded_titles_need_to_have_a_value_and_must_be_unique": "Excluded Titles need to have a value and must be unique",
    "excused": "excused",
    "exempt": "Exempt",
    "existing_integrations": "Existing Integrations",
    "expiration_date": "Expiration Date",
    "explore": "Explore",
    "export": "Export",
    "export_downloaded": "Export Downloaded",
    "export_gradebook": "Export Gradebook",
    "export_management": "Export Management",
    "export_management_description": "Allows users to create, modify, and delete Export Schedules.",
    "export_results": "Export Results",
    "export_schedule": "Export Schedule",
    "export_will_occur_shortly": "Export Will Occur Shortly",
    "exported": "Exported",
    "exported_by": "Exported By",
    "exports": "Exports",
    "extact_match": "extact match",
    "external": "External",
    "failed": "Failed",
    "failed_to_delete": "Failed To Delete",
    "failed_to_pause": "Failed to Pause",
    "failed_to_resume": "Failed to Resume",
    "failed_to_save": "Failed to Save",
    "false_feedback": "False Feedback",
    "february": "February",
    "feedback": "Feedback",
    "field": "Field",
    "field_delimiter": "Field Delimiter",
    "field_enclosed_by": "Field Enclosed By",
    "field_enclosure": "Field Enclosure",
    "field_must_contain_number": "This field must contain a number!",
    "field_of_study": "Field of Study",
    "fifth": "Fifth",
    "file_encoding": "File Encoding",
    "file_lms_not_available": "File may not be available in LMS file browser",
    "file_preview_settings": "File Preview Settings",
    "file_size": "File Size",
    "file_upload": "File Upload",
    "filefolders": "File Folders",
    "files": "Files",
    "files_in_use": "Files In Use",
    "files_per_submission": "Files Per Submission",
    "files_to_be_used": "Files To Be Used",
    "fill_in_all_the_required_fields": "Fill In All The Required Fields",
    "filter_by": "Filter By",
    "filter_by_course_id": "Filter by Course Id",
    "filter_by_date": "Filter by Date",
    "filter_type": "Filter Type",
    "final_answer": "Final Answer",
    "find_existing_question": "Find Existing Question",
    "find_text": "Find Text",
    "finish": "Finish",
    "first": "First",
    "first_inspect_your_rows_prior_to_deployment": "First Inspect Your Rows Prior to Deployment",
    "first_term_attended": "First Term Attended",
    "first_weekday": "First Weekday",
    "fix_validation_errors_before_continuing": "Fix validation errors before continuing",
    "folders": "Folders",
    "folders_become_modules": "Folders become Modules",
    "for_download": "for download",
    "for_id_completion_lingo": "For ID Completion: Based on the module plan provided by the SME, provide a brief list of possible multimedia or interactive additions to the course that will provide engagement, interactivity, collaboration, personalization, and intuition (see ID Rubric). Proposed elements should also focus on supporting student acquisition of critical behaviors. Include alignment to the module learning objectives and description (format provided). Provide details on the type of media, production requirements, and overall scope.",
    "format_for_binary_data_in_csv": "Format for binary data in csv",
    "format_for_date_values_in_csv": "Format for date values in csv",
    "format_for_time_values_in_csv": "Format for time values in csv",
    "format_for_timestamp_values_in_csv": "Format for timestamp values in csv",
    "format_highlighted_sql_(ctrl_+_shift)": "Format Highlighted SQL (Ctrl/Cmd + Shift)",
    "format_sql_(ctrl_+_shift)": "Format SQL (Ctrl/Cmd + Shift)",
    "formula": "Formula",
    "formula_definition": "Formula Definition",
    "fourth": "Fourth",
    "friday": "Friday",
    "friendly_description": "Friendly Description",
    "friendly_name": "Friendly Name",
    "friendly_name_for_your_identity_provider": "Friendly Name for your identity provider",
    "friendly_name_wizard_lingo": "Friendly Name: used to distinguish the integration in Scaffold",
    "from": "From",
    "from_url": "From URL",
    "from_xml": "From XML",
    "gender": "Gender",
    "general_feedback": "General Feedback",
    "generate_preview": "Generate Preview",
    "generation": "Generation",
    "getting_csv": "Getting CSV",
    "getting_files": "Getting Files",
    "global": "Global",
    "gpa": "GPA",
    "grade": "Grade",
    "grade_columns": "Grade Columns",
    "grade_data_export": "Grade data export",
    "grade_history": "grade history",
    "grade_list_by_student": "Grade List by Student",
    "grade_scale": "Grade Scale",
    "grade_scale_title": "Grade Scale Title",
    "grade_table_csv": "Grade Table CSV",
    "gradebook": "Gradebook",
    "gradebook_data": "Gradebook Data",
    "gradebook_item": "Gradebook Item",
    "gradecolumnattempts": "Grade Column Attempts",
    "gradecolumnentry": "Grade Column Entry",
    "gradecolumns": "Grade Columns",
    "graded": "Graded",
    "graded_survey": "Graded Survey",
    "gradeentry": "Grade Entry",
    "grader": "grader",
    "grades": "Grades",
    "gradescales": "Grade Scales",
    "gradeschemas": "Grade Schemas",
    "gradingcategories": "Grading Categories",
    "graduation_term": "Grad. Term",
    "graphs": "Graphs",
    "greeting_email_for_new_users_has_been_updated": "Greeting Email for New Users has been Updated",
    "group_name": "Group Name",
    "group_title": "Group Title",
    "groups": "GROUPS",
    "groupsets": "Group Sets",
    "handling_external_links": "Handling External Links",
    "heading_preview": "Heading Preview",
    "heading_text_color": "Heading Text Color",
    "heading_text_color_description": "This controls page and section titles with the exception of H6",
    "heading_title": "Heading Title",
    "headshot": "Headshot",
    "here_is_what_the_color_styling_will_look_like_applied_to_buttons_and_links._to_make_changes,_adjust_the_color_in_the_section_above": "Here is what the color styling will look like applied to buttons and         links. To make changes, adjust the color in the section above",
    "hidden": "Hidden",
    "highest": "highest",
    "home": "Home",
    "hot_spot": "hot spot",
    "how_do_you_want_to_get_authenticated?": "How do you want to get authenticated?",
    "human_only": "Human Only",
    "icon": "Icon",
    "icon_category": "Icon Category",
    "icon_url": "Icon URL",
    "id": "ID",
    "identity_provider": "Identity Provider",
    "identity_provider_metadata_xml": "Identity Provider Metadata XML",
    "identity_providers": "Identity Providers",
    "if_a_signature_certificate_is_required_from_your_idp_for_slo_to_occur,_provide_this": "If a Signature Certificate is required from your IDP for SLO to occur, provide this",
    "if_enabled,_this_identity_provider_will_be_used_to_authenticate_users_via_sso_lingo": "If enabled, this identity provider will be used to authenticate users via SSO. If multiple identity providers are enabled, it will be one of the options available for users to authenticate with.",
    "if_enabled,_this_identity_provider_will_be_used_to_authenticate_users_via_sso._if_multiple_identity_providers_are_enabled,_it_will_be_one_of_the_options_available_for_users_to_authenticate_with.": "If enabled, this identity provider will be used to authenticate users via SSO. If multiple identity providers are enabled, it will be one of the options available for users to authenticate with.",
    "ignore_empty_rows_in_your_file_during_import": "Ignore empty rows in your file during import",
    "image": "Image",
    "import": "Import",
    "import_&_save_terms": "Import & Save Terms",
    "import_attempt": "Import Attempt",
    "import_by_course_id": "Import by Course ID",
    "import_cleared": "Import Cleared",
    "import_complete": "Import Complete",
    "import_courses": "Course Imports",
    "import_courses_that_end_before_this_date": "Import Courses That End Before This Date",
    "import_date": "Import Date",
    "import_existing_course_id": "Import to existing course ID",
    "import_failed": "Import Failed",
    "import_method": "Import Method",
    "import_patterns": "Import Patterns",
    "import_runs": "Import Runs",
    "import_start": "Start Import",
    "import_terms": "Import Terms",
    "import_to_be_paused": "Import to be Paused",
    "import_to_be_resumed": "Import to be Resumed",
    "import_update_complete": "Import Update Complete",
    "important": "Important",
    "imported": "Imported",
    "imported_blueprint": "Imported Entity",
    "importing": "Importing",
    "imports": "Imports",
    "in_progress": "In Progress",
    "inactive": "Inactive",
    "inbox": "Inbox",
    "include_all_category_quiz_banks": "Include all Category Quiz Banks",
    "include_all_system_quiz_banks": "Include all System Quiz Banks",
    "include_column_headers_in_the_exported_file": "Include column headers in the exported file",
    "include_headers": "Include Headers",
    "include_start_and_end_dates": "Include Start and End Dates",
    "incomplete": "Incomplete",
    "incorrect_answer_selection_for": "Incorrect Answer Selection for",
    "incorrect_feedback": "Incorrect Feedback",
    "individual_student_data": "Individual Student Data",
    "info": "info",
    "inline": "Inline",
    "input": "Input",
    "input_text_to_find": "Input text to find",
    "insert": "Insert",
    "insert_before": "Insert Before",
    "instituion_gpa": "Institution GPA",
    "institution_attempted_hours": "institution attempted hours",
    "institution_earned_hours": "institution earned hours",
    "institution_gpa_hours": "institution gpa hours",
    "instructions": "Instructions",
    "instructor_feedback": "Instructor Feedback",
    "integration": "Integration",
    "integration_info": "Integration Info",
    "integration_information": "Integration Information",
    "integration_name": "Integration Name",
    "integration_name_tooltip": "A name for you to refer to in the future",
    "integration_system_note": "Please enter the information for the system you are connecting to.",
    "integration_type": "Integration Type",
    "integration_url": "Integration URL",
    "integration_url_tooltip": "The non SSO URL to the Desired System (e.g. https://k16.instructure.com)",
    "integration_url_wizard_lingo": "Integration URL: the domain or the rest api endpoint to the Canvas instance",
    "integrations": "Integrations",
    "integrations_still_gathering_terms": "Integrations Still Gathering Terms",
    "interaction": "Interaction",
    "invalid": "Invalid",
    "invalid_provider_name": "Must have no whitespace or underscores and be more than 5 characters",
    "invite_users": "Invite Users",
    "is_processing": "Is Processing",
    "issue_enabling_identity_provider_at_this_time.": "Issue enabling Identity Provider at this time.",
    "issuer_url_that_indicates_the_issuer_of_the_response": "Issuer URL that indicates the issuer of the response",
    "it_must_contain": "It must contain",
    "it_seems_you_are_not_authorized_for_scaffold": "It seems you are not authorized for Scaffold",
    "it_will_take_about_5_mins_before_you_are_able_to_see_the_updates_on_login.": "It will take about 5 mins before you are able to see the updates on login.",
    "item_read": "Item Read",
    "item_state": "Item State",
    "item_submit_edit": "Submit/Edit Item",
    "item_type": "Item Type",
    "items": "Items",
    "items_create": "Create Items",
    "items_no_search_made_yet": "Items in this list will not load until a search is executed",
    "items_per_page": "Items Per Page",
    "january": "January",
    "july": "July",
    "june": "June",
    "k16_security_and_architecture": "K16's Security and Architecture",
    "k16_security_documentation_pdf": "K16 - Security Documentation.pdf",
    "key": "Key",
    "key_add": "Add Key",
    "key_model": "Model Key",
    "key_name_no_white_spaces": "Key name cannot contain white spaces",
    "key_name_unique": "Key name has to be unique",
    "lakehouse": "Lakehouse",
    "last_accessed": "last accessed",
    "last_day": "Last Day",
    "last_edited": "Last Edited",
    "last_imported": "Last Imported",
    "last_page": "Last Page",
    "last_term_attended": "last term attended",
    "late": "late",
    "later": "Later",
    "launch": "Launch",
    "launch_url": "Launch URL",
    "left_match": "Left Match",
    "letter_grade": "Letter Grade",
    "level": "level",
    "legend_selected_tooltip": "The entity you have selected.",
    "legend_source_tooltip": "Entities that reference the selected entity (their foreign key points to the selected entity's primary key).",
    "legend_target_tooltip": "Entities that the selected entity references (the selected entity's foreign key points to these entities' primary keys).",
    "light_theme": "Light Theme",
    "lineage": "Lineage",
    "link": "Link",
    "link_missing_rubric": "missing rubric",
    "link_to_announcement": "Link to Announcement",
    "link_to_assignment": "Link to Assignment",
    "link_to_discussion": "Link to Discussion",
    "link_to_item": "Link to Item",
    "link_to_page": "Link to Page",
    "link_to_topic": "Link to Topic",
    "linked_lms": "Linked LMS",
    "links": "Links",
    "list_all_assignments_lingo": "List all assignments. This may include discussion board postings and other student submissions for this module.",
    "list_all_required_and_supplemental_readings_lingo": "List all required and supplemental readings/resources for this module, including links to articles, videos, and facilitator guides for live lessons.",
    "list_the_course_outcome_course_competencies_lingo": "List the course outcome, course competencies, and supporting LO/Skills for this module",
    "list_the_types_of_content_lingo": "List the types of content to be authored for this module. This may include introductory content or other course content that is aimed towards helping students achieve critical behaviors. The goal of asynchronous learning is on content comprehension. IDs to assist in targeting the optimal instructional approach.",
    "lms": "LMS",
    "lms_course_id": "LMS Course ID",
    "lms_data_direction": "LMS Data Direction",
    "lms_id": "LMS ID",
    "lms_link": "LMS Link",
    "lms_message": "LMS Message",
    "lms_semester_id": "LMS Semester ID",
    "lms_term_id": "LMS Term ID",
    "lms_type": "LMS Type",
    "load_more": "Load More",
    "local_time": "Local Time",
    "location": "Location",
    "location_type": "Location Type",
    "locations": "Locations",
    "lock": "Lock",
    "lock_date": "Lock Date",
    "lock_until": "Lock Until",
    "login": "Login",
    "logo": "Logo",
    "logo_dark": "Dark Theme Logo",
    "logout": "Logout",
    "lowercase": "Lowercase",
    "lti_details": "LTI Details",
    "lti_quiz": "LTI Quiz",
    "lti_tool": "LTI Tool",
    "mailing_address": "Mailing Address",
    "mainling_address": "Mailing Address",
    "make_sure_your_identity_provider_has_also_enabled_slo._can_be_found_in_the_xml_content_typically_with_the_element": "Make sure your identity provider has also enabled SLO. Can be found in the XML content typically with the element",
    "manage": "Manage",
    "manage_admin": "Manage Admin Settings",
    "manage_datax_import": "Import Management",
    "manage_datax_import_description": "Allows users to import data to create data entities.",
    "manage_imports": "Manage Imports",
    "manage_imports_definition": "Allows users access to initiate, pause, and abort imports.",
    "manage_integrations_definition": "Access to create, edit, and delete Integrations.",
    "manage_reports": "Manage Reports",
    "manage_reports_definition": "Access to create, edit, and delete reports.",
    "manage_roles": "Manage Roles",
    "manage_roles_definition": "Access to create new roles and edit permissions in a role.",
    "manage_sso_definition": "Access to create, edit, and delete Single Sign On.",
    "manage_users": "Manage Users",
    "manage_users_definition": "Access to the Users & Roles page allows creating, editing, and deleting user accounts. Users will have read-only access to view roles and their associated permissions.",
    "mange_roles": "Manage Roles",
    "manual_login_url": "Manual Login Url",
    "manual_login_url_tooltip": "Optional: This will be used to get access with if the login page isn't as expected based on the provided integration url",
    "map_to_module_objective": "Map to Module Objective",
    "march": "March",
    "margin_of_error": "Margin of error",
    "margin_type": "Margin Type",
    "marital_status": "Marital Status",
    "mastery_at": "Mastery at",
    "match_case_on_replace": "Match Case on Replace",
    "matching": "Matching",
    "max": "Max",
    "max_file_size": "Max file size",
    "max_of_6_labels": "Max of 6 Labels",
    "may": "May",
    "medium": "Medium",
    "mentioned_you_in_comment": "mentioned you in a comment",
    "menu_preview": "Menu Preview",
    "merge_consecutive_labels": "Merge Consecutive Labels",
    "merge_items/documents": "Merge Items/Documents",
    "message": "Message",
    "message_no_associated_courses": "There are no courses associated with this message.",
    "message_type": "Message Type",
    "messages": "Messages",
    "mfa": "MFA",
    "mfa_can_be_setup_on_your_phone_via_text_messages_or_through_an_authenticator_app_or_both": "MFA can be setup on your phone via text messages or through an authenticator app or both",
    "mfa_code": "MFA Code",
    "mfa_has_not_yet_been_enabled_lingo": "MFA has not yet been enabled for this account.",
    "mfa_must_be_setup_in_order_to_continue": "MFA must be setup in order to continue",
    "mfa_setup": "MFA Setup",
    "middle_name": "Middle Name",
    "migrate_all_journals": "Migrate all journals",
    "migrate_bookmarks_as_page": "Migrate Bookmarks as Page",
    "migrate_discussions": "Migrate Discussions",
    "migration": "Migration",
    "migration_cleared": "Migration Cleared",
    "migration_log": "Migration Log",
    "migration_log_entry": "Migration Log Entry",
    "migration_runs": "Migration Runs",
    "migration_to_be_paused": "Migration to be Paused",
    "migration_to_be_resumed": "Migration to be Resumed",
    "migrations": "Migrations",
    "min": "Min",
    "minimum_number_of_characters": "Minimum Number of Characters",
    "minimum_score": "Minimum Score",
    "missing": "missing",
    "missing_assignment": "Missing Assignment",
    "missing_discussion": "Missing Discussion",
    "missing_email": "missing email",
    "missing_external_tool": "Missing External Tool",
    "missing_external_url": "Missing External URL",
    "missing_file": "Missing File",
    "missing_forum": "Missing Forum",
    "missing_message": "Missing Message",
    "missing_page": "Missing Page",
    "missing_quiz": "Missing Quiz",
    "missing_quiz_bank": "Missing Quiz Bank",
    "mixed": "Mixed",
    "mode_add": "Add Mode",
    "mode_already_exist": "That mode already exists for this type",
    "mode_choose": "Choose Mode",
    "mode_create_new": "Create New Mode",
    "mode_no_white_space": "New mode cannot contain white spaces",
    "model_already_exist": "Model has to be unique",
    "model_delete": "Delete Model",
    "model_new": "New Model",
    "model_no_white_space": "Model name cannot contain white spaces",
    "modes_data": "Data Modes",
    "modified": "modified",
    "module": "Module",
    "module_objectives": "Module Objectives",
    "module_title": "Module Title",
    "module_titles_to_exclude": "Module Titles to Exclude",
    "moduleitems": "Module Items",
    "modules": "Modules",
    "monday": "Monday",
    "month": "Month",
    "monthly": "Monthly",
    "months": "Months",
    "more_info": "More Info",
    "most_recent_score": "most recent score",
    "move": "Move",
    "multi-factor_authentication": "Multi-Factor Authentication",
    "multimedia/interactive_suggestions": "Multimedia/Interactive Suggestions (For ID Completion)",
    "multiple_answer": "Multiple Answer",
    "multiple_choice": "Multiple Choice",
    "multiple_dropdown": "Multiple Dropdown",
    "multiple_fill_in_the_blank": "Multiple Fill in The Blank",
    "must_be_a_unique_name": "Must Be A Unique Name",
    "must_be_a_unique_name_--_this_includes_removed_entities": "Must be a Unique Name -- This includes Removed Entities",
    "must_be_a_valid_url": "Must be a valid URL",
    "must_be_enrolled_to_view_courses": "Course Access requires enrollment",
    "must_be_paused_before_able_to_cancel": "Must be Paused Before Able to Cancel",
    "must_be_unique": "Must be unique",
    "must_contain_only_letters,_underscores,_decimal_digits_(0-9),_and_dollar_signs_(“$”)": "Must contain only letters, underscores, decimal digits (0-9), and dollar signs (“$”)",
    "must_have_a_phone_number_setup._this_can_be_provided_from_the_profile_page": "Must have a phone number setup. This can be provided from the profile page",
    "must_have_a_valid_entity_name_to_upload_with": "Must have a valid entity name to upload with",
    "must_have_at_least_one_file_available": "Must have at least one file available",
    "must_have_one_valid_integration_for_both_source_and_destinations_in_order_to_migrate": "Must have one valid integration for both source and destinations in order to migrate",
    "must_have_one_valid_integration_in_order_to_import": "Must have one valid integration in order to import",
    "must_have_permission_to_manage_blueprints": "Must have permission to manage blueprints",
    "must_have_validated_sql_query": "Must have Validated SQL Query",
    "must_start_with_a_letter_(a-z,_a-z)_or_an_underscore_(“_”)": "Must start with a letter (A-Z, a-z) or an underscore (“_”)",
    "name": "Name",
    "name_first": "First Name",
    "name_friendly": "Friendly Name",
    "name_last": "Last Name",
    "name_your_blueprint": "Name your Blueprint",
    "navigation_item": "Navigation Item",
    "need_a_destination_integration_to_start_migration": "Need a Destination Integration to Start Migration",
    "need_a_source_integration_to_start_a_migration": "Need a Source Integration to Start a Migration",
    "need_to_provide_files_to_be_uploaded": "Need to provide files to be uploaded",
    "needs_to_be_an_email": "Needs to be an email",
    "new": "New",
    "new_archive": "New Import",
    "new_blueprint": "New Blueprint",
    "new_business_glossary": "New Business Glossary",
    "new_entity_import": "New Entity Import",
    "new_folder": "New Folder",
    "new_grade_level": "New Grade Level",
    "new_identity_provider": "New Identity Provider",
    "new_import": "New Import",
    "new_integration": "New Integration",
    "new_migration": "New Migration",
    "new_module_objective": "New Module Objective",
    "new_password": "New Password",
    "new_role": "New Role",
    "new_term": "New Term",
    "new_user": "New User",
    "new_users": "New Users",
    "new_version_available": "New Version Available",
    "new_workbook": "New Workbook",
    "new_worksheet": "New Worksheet",
    "next": "Next",
    "next_page": "Next Page",
    "next_scheduled_export_will_now_occur_on": "Next Scheduled Export Will now occur on",
    "next_scheduled_export_will_occur_at": "Next Scheduled Export Will Occur On",
    "next_scheduled_export_will_occur_on": "Next Scheduled Export Will Occur On",
    "next_scheduled_snapshot_will_occur_at": "Next Scheduled Snapshot will occur at",
    "no": "No",
    "no_assignments_to_display": "No Assignments to Display",
    "no_authorized_integrations": "This user either does not have any authorized integrations assigned or their permissions do not require the assignment of authorized integrations.",
    "no_changes_to_save": "No Changes to Save",
    "no_columns_found": "No Columns Found",
    "no_courses_enrolled": "No Courses To Display",
    "no_courses_found": "No Courses Found",
    "no_courses_found_for_term": "No Courses found for this Term",
    "no_courses_found_for_this_term": "No Courses found for this Term",
    "no_coursesections": "No Course Sections to Display.",
    "no_current_mentions": "No Current Mentions",
    "no_detections_found._check_back_later_for_more_results": "No detections found. Check back later for more results",
    "no_entity_found": "No Entity Found",
    "no_entity_version_found": "No Entity Version Found",
    "no_entry": "No Entry",
    "no_files_associated_with_submission": "No files associated with submission",
    "no_files_found": "No Files Found",
    "no_files_to_display": "No Files to Display",
    "no_files_to_zip": "No Files to Zip",
    "no_folders_to_display": "No Folders to Display",
    "no_grade": "No Grade",
    "no_grades_to_display": "No Grades To Display",
    "no_gradescale": "No grade scale to display",
    "no_groups": "No Groups To display",
    "no_hold_courses_found": "No Hold Courses Found",
    "no_identity_providers_currently": "No Identity Providers Currently",
    "no_imports_found": "No Imports Found",
    "no_integration_found": "No Integration Found",
    "no_integrations_match_filter": "No integrations match filter",
    "no_integrations_to_display": "No Integrations. Click on New Integration above",
    "no_messages_to_display": "No Messages to Display",
    "no_migrations_found": "No Migrations Found",
    "no_moduleitems": "No module items to display",
    "no_modules": "No Modules to Display",
    "no_outcome_alignment": "No outcome alignment.",
    "no_outcomes": "No Outcomes to Display",
    "no_results": "No Results",
    "no_results_found": "No Results Found",
    "no_roles_available._please_try_again_shortly": "No Roles available. Please try again shortly",
    "no_sample_data_found": "No Sample Data Found",
    "no_sample_data_to_display": "No Sample Data to Display",
    "no_schedules_found": "No Schedules Found",
    "no_semester_found": "No Semesters Found",
    "no_sent_messages": "No Sent Messages to Display.",
    "no_snapshots_found": "No Snapshots Found",
    "no_spacing": "No Spacing",
    "no_students_found": "No Students Found",
    "no_students_to_display": "No Students to Display",
    "no_submission_details": "No additional submission details to display.",
    "no_tables_found": "No Tables Found",
    "no_tasks_assigned": "No Tasks Assigned",
    "no_updates_made": "No Updates Made",
    "no_valid_occurrences_before_the_end_date": "No valid occurrences before the end date",
    "no_whitespace": "No whitespace",
    "no_whitespace_allowed": "No whitespace allowed",
    "no-semesters-found": "No Semesters Found",
    "no-terms-found": "No Terms Found",
    "node_id": "Node ID",
    "none": "None",
    "not_a_unique_name": "Not a Unique Name",
    "not_authorized_to_view_any_integrations": "You do not have permission to view any integrations",
    "not_found": "Not Found",
    "not_setup": "Not Setup",
    "note": "Note",
    "note:_a_reoccurring_snapshot_schedule,_will_always_take_a_snapshot_of_the_latest_deployed_version_of_a_blueprint.": "Note: a reoccurring Snapshot schedule, will always take a Snapshot of           the latest deployed version of a Blueprint.",
    "notes": "Notes",
    "notes_and_ideas": "Notes and Ideas",
    "notifications": "Notifications",
    "notifications_clear": "Clear Notifications",
    "notifications_menu_intro": "Imports and downloads that are happening in the background can be viewed here. You are able to navigate throughout the app without disrupting these processes and will receive a notification when they are complete",
    "november": "November",
    "now": "Now",
    "null_if_values": "Null If Values",
    "nullable": "Nullable",
    "number_of_questions": "Number of Questions",
    "number_of_solutions": "Number of Solutions",
    "number_to_display": "Numbers To Display",
    "numbers": "Numbers",
    "numerical": "Numerical",
    "nurmeric": "Numeric",
    "oauth_consumer_key": "OAuth Consumer Key",
    "oauth_consumer_secret": "OAuth Consumer Secret",
    "objectives": "Objectives",
    "objectives_for_module": "Objectives for Module",
    "occured": "Occurred",
    "occurred": "Occurred",
    "occurs_at": "Occurs at",
    "october": "October",
    "of": "of",
    "of_contracted_amount": "of Contracted Amount",
    "off": "Off",
    "offline": "offline",
    "omit_separator_labels": "Omit Separator Labels",
    "on": "On",
    "on_day_of_month": "On Day Of Month",
    "on_occurrence_of_day": "On Occurrence Of Day",
    "once_all_fields_have_been_populated_wizard_lingo": "Once all fields have been populated, click the Create Integration link. When clicking the Create Integration link, Canvas access tokens will automatically be generated, and the terms will be retrieved from Canvas.",
    "once_you’ve_added_your_details_to_the_template,_upload_the_csv": "Once you’ve added your details to the template, upload the csv",
    "one_time": "One Time",
    "only_authorized_integrations": "Authorized Integrations Only",
    "only_numbers": "Only Numbers",
    "only_numbers_and_no_spacings": "Only numbers and no spacings",
    "only_related": "Only Related",
    "open": "Open",
    "open_entry": "open entry",
    "open_in_new_tab": "Opens in New Tab",
    "open_in_worksheets": "Open In Worksheets",
    "open_links_in_new_tab": "Open Links In New Tab",
    "open_new_tab": "Open in New Tab",
    "open_the_link_in_a_new_tab_lingo": "Open the link in a new tab. This may be required due to security restriction on the site you are linking too preventing opening it in a frame",
    "open_view": "Open View",
    "optional": "Optional",
    "options": "Options",
    "or": "or",
    "org_unit_id": "Org Unit ID",
    "org_unit_id_tooltip": "The ID of the Organization or Department in Brightspace that the integration will interact with",
    "organization_id": "Organization ID",
    "our_penetration_test_report_is_a_transparent_demonstration_of_our_commitment_to_the_security_and_trust_of_our_customers": "Our penetration test report is a transparent demonstration of our commitment to the security and trust of our customers. It provides a comprehensive overview of the simulated attack on our systems and the vulnerabilities identified, along with the steps we have taken to remediate them. By sharing this report, we aim to provide our customers with assurance that we take security seriously and are committed to ensuring the protection of their data.",
    "our_soc_2_report_is_a_detailed_overview_of_our_commitment_to_security": "Our SOC 2 report is a detailed overview of our commitment to security, availability, processing integrity, confidentiality, and privacy.         It provides customers with independent assurance that our systems and processes meet industry-standard criteria established by the         American Institute of Certified Public Accountants (AICPA). The SOC 2 reports cover controls around security, availability, and confidentiality of customer data.",
    "outcome": "Outcome",
    "outcome_groups": "Outcome Groups",
    "outcomes": "Outcomes",
    "overall_attempted_hours": "overall attempted hours",
    "overall_earned_hours": "overall earned hours",
    "overall_gpa": "overall gpa",
    "overall_gpa_hours": "overall GPA hours",
    "overall_standing": "overall standing",
    "overlay": "Overlay",
    "owner": "Owner",
    "page_not_found": "Page Not Found",
    "page_settings": "Page Settings",
    "page_title": "Page Title",
    "pages": "Pages",
    "paginate_first_page": "First Page",
    "paginate_items_per_page": "Items Per Page",
    "paginate_per_page": "Per Page",
    "paginate_previous_page": "Previous Page",
    "participants": "participants",
    "partition_by": "Partition By",
    "partner": "Partner",
    "passed": "Passed",
    "password": "Password",
    "password_confirm": "Confirm Password",
    "password_confirm_attributes": "Please confirm all attributes",
    "password_forgot": "Forgot Password",
    "password_new": "New Password",
    "password_new_set": "Set New Password",
    "password_old": "Old Password",
    "password_policies": "Password Policies",
    "password_recovery_instructions_sent": "Password recovery instructions have been sent to the email associated with your account",
    "password_refresh": "Password Refresh",
    "password_requirement": "Password Requirements",
    "password_policy_load_failed_continue": "Password requirements could not be loaded. You can still set a new password below.",
    "password_tooltip": "The password for the account in the system the integration is connected to",
    "paste_user_emails": "Paste User Emails",
    "paste_xml_for_your_tool_configuration": "Paste XML for your tool configuration",
    "pattern_matches": "Pattern Matches",
    "pause_all_exports": "Pause All Exports",
    "pause_all_imports": "Pause All Imports",
    "pause_exports": "Pause Exports",
    "pause_import": "Pause Import",
    "pause_imports": "Pause Imports",
    "pause_migration": "Pause Migration",
    "paused": "Paused",
    "pausing_all_imports_will_stop_all_queued\\n_courses_from_being_processed_any_further.": "Pausing all imports will stop all queued\\n courses from being processed any further.",
    "pausing_will_stop_all_queued_courses_meant_to_be_imported_from_being_processed_any_further.": "Pausing will stop all queued courses meant to be imported from being processed any further.",
    "pausing_will_stop_all_queued_courses_meant\\n_to_be_exported_from_being_processed_any_further.": "Pausing will stop all queued courses meant\\n to be exported from being processed any further.",
    "pdf": "PDF",
    "pen_test_report": "Pen Test Report",
    "pending_removal": "Pending Removal",
    "pending_scan": "Pending Scan",
    "people": "People",
    "per_item": "Per Item",
    "per_page": "Per Page",
    "permission": "Permission",
    "permission_required_syncing": "Permission is required in order to sync courses to the LMS.",
    "personal_information": "personal information",
    "phone_number": "Phone Number",
    "phone_type": "Phone Type",
    "picture_url": "Picture Url",
    "pidm": "PIDM",
    "please_download_an_authenticator_app_lingo": "Please download an Authenticator App from your smart phone's app store. Once installed, please scan the QR code with your Authenticator App to setup MFA.",
    "please_enable_cross_site_or_third_party_cookies_lingo": "Please enable Cross Site or Third Party Cookies in order to View Tableau Dashboard",
    "please_enter_the_code_that_is_displayed_within_your_authenticator_app": "Please enter the code that is displayed within your Authenticator App.",
    "please_make_sure_the_blueprint_name_matches_the_blueprint_you_are_trying_to_delete": "Please make sure the Blueprint name matches the Blueprint you are trying to delete",
    "please_note_when_creating_a_schedule,_that_you_can_only_have_one_schedule_per_an_entity.": "Please note when creating a schedule, that you can only have one schedule per an entity.",
    "please_provide_the_code_sent_to_your_phone_number": "Please provide the code sent to your phone number",
    "please_review_the_columns_below_to_resolve_errors_or_make_updates._columns_that_were_not_in_an_acceptable_format_have_been_updated_where_possible.": "Please review the columns below to resolve errors or make updates.             Columns that were not in an acceptable format have been updated where possible.",
    "please_run_the_query_prior_to_publishing": "Please run the query prior to publishing",
    "please_set_up_the_integration_to_your_canvas_instance_lingo": "Please set up the integration to your Canvas instance by populating the needed fields below.",
    "please_verify_your_sample_rows": "Please verify your sample rows",
    "points": "points",
    "points_per_question": "Points Per Question",
    "points_possible": "Points Possible",
    "possible_choices": "possible choices",
    "possible_solutions": "Possible Solutions",
    "practice": "Practice",
    "practice_quiz": "Practice Quiz",
    "prefix": "Prefix",
    "preparing": "Preparing",
    "preparing_file_for_download_has_failed": "Preparing File for download has failed",
    "preparing_zip_for_download": "Preparing Zip for download",
    "preview": "Preview",
    "preview_changes_not_save_lingo": "This is a preview, changes made here can not be saved",
    "preview_your_xml_metadata_to_validate_if_accurate_or_needing_to_check_for_email_address_attribute": "Preview Your XML metadata to validate if accurate or needing to check for email address attribute",
    "previews": "Previews",
    "previous": "Previous",
    "primary_brand_color": "Primary Brand Color",
    "primary_brand_color_description": "This controls button colors and navigation background on select/hover",
    "primary_button": "Primary Button",
    "primary_key": "Primary Key",
    "primary_text_color": "Primary Text Color",
    "primary_text_color_descriptions": "This controls the main text color and child sidebar text color",
    "process": "Process",
    "process_data": "Process Data",
    "processed_user_emails": "Processed User Emails",
    "processing": "Processing",
    "production": "Production",
    "proficiency_calculation": "Proficiency Calculation",
    "proficiency_rating": "Proficiency Rating",
    "profile": "Profile",
    "progress_evaluation": "Progress Evaluation",
    "provide_an_issuer_url_and_it_will_populate_values_for_the_authentication_endpoint,_token_endpoint,_userinfo_endpoint,_and_jwks_uri": "Provide an issuer URL and it will populate values for the authentication endpoint, token endpoint, userInfo endpoint, and jwks_uri",
    "provide_at_least_four_characters": "Provide at least four characters",
    "provide_descriptions_for_each_element_lingo": "Provide descriptions for each element. Include essential questions to support the explanation",
    "provide_emails_below_for_each_user_wizard_lingo": "You can invite additional users to your Scaffold instance by entering their email addresses below and separating each email with a comma or on a new line. After entering the email addresses, click the Process link. Their username will be auto-generated from their email alias and you will be able assign permission accordingly. Make any additional adjustments if needed, then click Create Accounts.",
    "provide_the_attribute_identifier_that_corresponds_to_a_user's_email_address": "Provide the Attribute identifier that corresponds to a user's email address",
    "provide_the_code_from_the_text_message_to_complete_login": "Provide the code from the text message to complete login",
    "publish": "Publish",
    "publish_&_deploy": "Publish & Deploy",
    "publish_&_stage": "Publish & Stage",
    "publish_version": "Publish Version",
    "published": "Published",
    "published_assignment": "Published Assignment",
    "published_discussion": "Published Discussion",
    "published_exam": "Published Exam",
    "published_external_tool": "Published External Tool",
    "published_external_url": "Published External URL",
    "published_file": "Published File",
    "published_forum": "Published Forum",
    "published_page": "Published Page",
    "pull_latest": "Pull Latest",
    "purchased_courses": "Purchased Courses",
    "push_courses_or_any_changes_from_scaffold_to_lms": "Push course or any changes from Scaffold to LMS",
    "push_update_of_changes_from_parent_course_to_children": "Push update of changes from Parent course to Children",
    "push_updates_to_child_courses": "Push Updates to Child Courses",
    "query_sql": "Query SQL",
    "question": "Question",
    "question_details": "Question Details",
    "question_information": "Question Information",
    "question_name": "Question Name",
    "question_text": "Question Text",
    "question_type": "Question Type",
    "questions": "Questions",
    "questions_additional": "Additional Questions",
    "questions_concerns_next_steps": "Questions/ Concerns/ Next Steps",
    "questions_contact_us": "If you have any questions, contact us at",
    "queued": "Queued",
    "quick_help": "Quick Help",
    "quiz_bank": "quiz bank",
    "quiz_bank_title": "Quiz Bank Title",
    "quiz_banks": "Quiz Banks",
    "quiz_description": "Quiz Description",
    "quiz_settings": "Quiz Settings",
    "quiz_title": "Quiz Title",
    "quiz_type": "Quiz Type",
    "quizanswers": "Quiz Answers",
    "quizbank": "Quiz Bank",
    "quizbanks": "Quiz Banks",
    "quizgroups": "Quiz Groups",
    "quizquestions": "Quiz Questions",
    "quizzes": "Quizzes",
    "rating_description": "Rating Description",
    "rating_score": "Rating Score",
    "rating_title": "Rating Title",
    "raw_data": "Raw Data",
    "raw_data_csv": "Raw Data CSV",
    "raw_data_csv_student": "Raw Data CSV by Student",
    "raw_data_txt_student": "Raw Data TXT by Student",
    "read": "Read",
    "read_only_definition": "Allows users to view course data only.",
    "read_only_view": "Read only view",
    "read_tab_markup": "Read Tab Markup",
    "reading_resources": "Reading/Resources",
    "ready_to_deploy": "Ready To Deploy",
    "record_delimiter": "Record Delimiter",
    "recurring": "Recurring",
    "reference_id": "Reference ID",
    "referenced_by": "Referenced By",
    "references": "References",
    "reenable": "Re-enable",
    "refresh": "Refresh",
    "refresh_browser_log_back_in": "Please refresh your browser to get logged back in",
    "refresh_password": "Refresh Password",
    "refresh_semesters": "Refresh Semesters",
    "refresh_terms": "Refresh Terms",
    "refresh_token": "Refresh Token",
    "refreshing_terms": "Refreshing Terms",
    "refreshtoken": "Refresh Token",
    "regular_expression_match": "regular expression match",
    "relationship": "Relationship",
    "relationships": "Relationships",
    "release": "Release",
    "release_notes": "Release Notes",
    "remaining": "Remaining",
    "remove": "Remove",
    "remove_academic_hold": "Remove Academic Hold",
    "remove_image": "Remove Image",
    "remove_leading_and_trailing_spaces_from_field_values_automatically": "Remove leading and trailing spaces from field values automatically",
    "remove_logo": "Remove Logo",
    "remove_student_data": "Remove Student Data",
    "rename": "Rename",
    "replace_logo": "Replace Logo",
    "replace_text": "Replace Text",
    "reploy_new": "New Reply",
    "reply": "Reply",
    "reply_from": "Reply From",
    "reporting": "Reporting",
    "request_change": "Request Change",
    "required": "Required",
    "required_username_field_invalid_text": "This is a required field. The Username should not be an email or contain any spaces!",
    "requirement_6_99_characters": "Must be between 6-99 characters",
    "requirement_lowercase": "Must have a lowercase character",
    "requirement_minimum_length": "Minimum Length",
    "requirement_number": "Must have a number",
    "requirement_special_character": "Must include one of these characters: ^ $ * . [ ] { } ( ) ? - ! @ # % & / \\\", > < \\ : ; | _ ~",
    "requirement_uppercase": "Must have an uppercase character",
    "requirements": "Requirements",
    "requires_,anage_users": "*Requires Manage Users permission.",
    "requires_characters": "Requires Characters",
    "requires_view_integrations": "*Requires View Integrations permission.",
    "requirese_manage_users": "*Requires Manage Users permission.",
    "reset": "Reset",
    "reset_password": "Reset Password",
    "resolved": "Resolved",
    "restore_course": "Restore Course",
    "restore_failed": "Restore Failed",
    "restore_student_data": "Restore Student Data",
    "restoring": "Restoring",
    "results": "Results",
    "resume_all_exports": "Resume All Exports",
    "resume_all_imports": "Resume All Imports",
    "resume_import": "Resume Import",
    "resume_imports": "Resume Imports",
    "resume_migration": "Resume Migration",
    "resuming_all_imports_will_allow_all_courses_that_are\\n_currently_queued_to_continue_to_be_processed.": "Resuming all imports will allow all courses that are\\n currently queued to continue to be processed.",
    "resuming_will_allow_all_courses_meant_to_be_exported_that_are_currently_queued_to_continue_to_be_processed.": "Resuming will allow all courses meant to be exported that are currently queued to continue to be processed.",
    "resuming_will_allow_all_courses_meant_to_be_imported_that_are\\n_currently_queued_to_continue_to_be_processed.": "Resuming will allow all courses meant to be imported that are\\n currently queued to continue to be processed.",
    "retain_folder_descriptions_as_pages": "Retain Folder Descriptions as Pages",
    "retain_journal_description_from_content_area": "Retain Journal Description From Content Area",
    "retention_period": "Retention Period",
    "retention_rule": "Retention Rule",
    "retention_type": "Retention Type",
    "retention_years": "Years to Retain",
    "retry": "Retry",
    "review_columns": "Review Columns",
    "right_match": "Right Match",
    "role": "Role",
    "role_name": "Role Name",
    "role_permissions": "Role Permissions",
    "roles": "Roles",
    "row_add_new": "Add New Row",
    "row_count": "Row Count",
    "rows": "Rows",
    "rubric": "Rubric",
    "rubric_title": "Rubric Title",
    "rubrics": "Rubrics",
    "rule_effective_date": "Rule Effective Date",
    "run_highlighted_sql_(ctrl_+_enter)": "Run Highlighted SQL (Ctrl/Cmd + Enter)",
    "run_query_to_populate_sample_data": "Run query to populate sample data",
    "run_sql_(ctrl_+_enter)": "Run SQL (Ctrl/Cmd + Enter)",
    "run_sql_first_before_publishing": "Run SQL First Before Publishing",
    "safe_assign_percentage": "safe assign percentage",
    "sample_100_rows_of_data": "Sample 100 Rows of Data",
    "sample_rows": "Sample Rows",
    "sample_sql": "Sample SQL",
    "sampling_rows": "Sampling Rows",
    "saturday": "Saturday",
    "save": "Save",
    "save_&_continue_editing": "Save & Continue Editing",
    "save_&_exit": "Save & Exit",
    "save_as_blueprint_(ctrl_+_b)": "Save as Blueprint (Ctrl/Cmd + B)",
    "save_draft": "Save Draft",
    "save_email_template": "Save Email Template",
    "save_selected_terms": "Save Selected Terms",
    "save_worksheet_(ctrl_+_s)": "Save Worksheet (Ctrl/Cmd + S)",
    "saving": "Saving",
    "scaffold_transformation": "Scaffold Transformation",
    "scaffold_transformations_are_source_base_tables_with_transformations_to_create_the_neutral_data_model": "Scaffold Transformations are source base tables with transformations to create the neutral data model",
    "scan_failed": "Scan Failed",
    "scan_files_to_validate_for_import": "Scan Files to Validate for Import",
    "scanned": "Scanned",
    "scanning": "Scanning",
    "scanning_files": "Scanning Files",
    "schedule": "Schedule",
    "schedule_date": "Schedule Date",
    "schedule_description": "Schedule Description",
    "schedule_export": "Schedule Export",
    "schedule_frequency": "Schedule Frequency",
    "schedule_occurrence": "Schedule Occurrence",
    "schedule_snapshot": "Schedule Snapshot",
    "scheduled": "Scheduled",
    "scheduled_end_date": "Scheduled End Date",
    "scheduled_export_has_occurred": "Scheduled Export has Occurred",
    "schedules": "Schedules",
    "school_id": "School ID",
    "score": "Score",
    "score_title": "Score Title",
    "search": "Search",
    "search_assignments": "Search Assignments",
    "search_by": "Search By",
    "search_by_course_name,_course_code,_or_sis_id": "Search by course name, course code, or SIS ID",
    "search_entities": "Search Entities",
    "search_files": "Search Files",
    "search_for_students": "Search for Students",
    "search_integrations": "Search Integrations",
    "search_students": "Search Students",
    "search_term": "Search Term",
    "searching": "Searching",
    "second": "Second",
    "secondary_brand": "Secondary Brand",
    "secondary_brand_color": "Secondary Brand Color",
    "secondary_brand_color_description": "This controls parent sidebar background color",
    "secondary_button": "Secondary Button",
    "secret": "Secret",
    "secret_key": "Secret Key",
    "section": "section",
    "section_title": "section title",
    "security": "Security",
    "security_and_compliance": "Security and Compliance",
    "security_information": "Security Information",
    "security_statement": "K16 Solutions is committed to earning and maintaining our customers' trust by implementing robust security measures, and continuously monitoring and improving our systems. In addition to our commitment to security, we prioritize privacy and compliance by adhering to relevant regulations and industry standards to protect our customers' data to maintain their trust in our services",
    "see_discussion_post": "Please see discussion post for discussion replies.",
    "select": "Select",
    "select_a_date": "Select a Date",
    "select_a_field": "Select a Field",
    "select_a_version_to_compare": "Select a version to compare",
    "select_a_workbook_to_view": "Select a Workbook to View",
    "select_an_integration": "Select an Integration",
    "select_blueprint": "Select Blueprint",
    "select_blueprints_that_will_define_this_business_glossary_term": "Select blueprints that will define this business glossary term",
    "select_blueprints_to_reference": "Select blueprints to reference",
    "select_color": "Select Color",
    "select_course_for_hold": "Select Course For Hold",
    "select_date": "Select Date",
    "select_date_range_to_download_details_on_imported_courses": "Select Date Range to Download Details on Imported Courses",
    "select_dates": "Select Dates",
    "select_destination_integration": "Select Destination Integration",
    "select_file": "Select File",
    "select_folder": "Select Folder",
    "select_how_you’d_like_to_import": "Select How You’d Like to Import",
    "select_integration": "Select Integration",
    "select_item": "Select Item",
    "select_lms_for_tool": "Select LMS for Tool",
    "select_new_location": "Select new location",
    "select_role": "Select Role",
    "select_semester_to_import": "Select Semester to Import",
    "select_service_to_access": "Select Service to Access",
    "select_source_integration": "Select Source Integration",
    "select_status": "Select Status",
    "select_terms_to_import": "Select Terms to Import",
    "select_the_blueprint_that_will_serve_as_the_technical_definition_for_this_business_glossary_term._this_will_provide_an_objective_understanding_for_this_business_glossary_term": "Select the blueprint that will serve as the technical definition for this business glossary term. This will provide an objective understanding for this business glossary term",
    "select_the_blueprints_that_are_meant_to_be_associated_with_this_business_glossary_term._these_provide_additional_context_for_related_terminology_for_these_blueprints": "Select the blueprints that are meant to be associated with this business glossary term. These provide additional context for related terminology for these blueprints",
    "select_the_source_environment_if_you_don't_want_to_use_the_environment_of_this_instance": "Select the source environment if you don't want to use the environment of this instance",
    "select_time_scale": "Months or Years",
    "select_type": "Select Type",
    "select_version_to_compare": "Select Version To Compare",
    "select_your_logo": "Select Your Logo",
    "selected": "Selected",
    "selecting_an_entity_from_the_folder_tree_will_display_the_associated_columns": "Selecting an entity from the folder tree will display the associated columns",
    "semester": "semester",
    "semester_details": "Semester Details",
    "semester_id": "Semester ID",
    "semester_name": "semester name",
    "semester_sis_id": "Semester SIS ID",
    "send_message": "Send Message",
    "sent": "Sent",
    "separate_users_emails_by_comma": "Separate user emails by comma",
    "seperate_labels_with_accordians": "Seperate Labels with Accordians",
    "september": "September",
    "set_academic_hold": "Set Academic Hold",
    "set_root_org_unit": "Set Root Org Unit",
    "set_root_org_unit_tooltip": "Specify the root org unit for the integration to use as root for imports",
    "settings": "Settings",
    "setup": "Setup",
    "setup_additional_security_at_this_time": "Setup additional security at this time?",
    "shedules": "Schedules",
    "short_answer": "Essay",
    "short_description": "Short Description",
    "show_advanced_options": "Show Advanced Options",
    "show_all": "Show All",
    "show_column_totals": "Show Column Totals",
    "show_resolved": "Show Resolved",
    "sidebar_text_and_icon_color": "Sidebar Text and Icon Color",
    "sidebar_text_and_icon_color_description": "This controls parent sidebar text and icon color",
    "signature_certificate": "Signature Certificate",
    "significant_digits": "significant digits",
    "signin": "Sign In",
    "single_file": "Single File",
    "single_logout_url": "Single Logout URL",
    "sis_course_id": "SIS COURSE ID",
    "sis_semester_id": "sis semester id",
    "sis_term_id": "Term SIS ID",
    "sis_type": "SIS Type",
    "sis_user_id": "SIS User ID",
    "skip": "Skip",
    "skip_blank_lines": "Skip blank lines",
    "skipped": "skipped",
    "snapshot": "Snapshot",
    "snapshot_by": "Snapshot By",
    "snapshot_history": "Snapshot History",
    "snapshot_manage_description": "Allows users to create, modify, and delete Snapshots and Snapshot Schedules.",
    "snapshot_schedule": "Snapshot Schedule",
    "snapshot_taken_on": "Snapshot Taken on",
    "snapshot_will_be_taken_shortly": "Snapshot will be taken shortly",
    "snapshots": "Snapshots",
    "snapshots_are_copies_of_a_blueprint_at_a_specific_time._to_create_a_snapshot,_select_the_--snapshot_schedule--": "Snapshots are copies of a Blueprint at a specific time. To create a Snapshot, select the Snapshot Schedule button",
    "snapshots_failed_to_delete": "Snapshots failed to delete",
    "snapshots_manage": "Snapshots Management",
    "snowflake_access": "Snowflake Access",
    "snowflake_access_definition": "Provides users with access to Snowflake.",
    "soap_password": "SOAP Password",
    "soap_username": "SOAP Username",
    "soc_2_type_i": "SOC 2 TYPE I",
    "sort_by": "Sort By",
    "source": "Source",
    "source_integrations": "Source Integrations",
    "source_only": "Source Only",
    "specify_correct_answers": "specify correct answers",
    "sql_statement": "SQL Statement",
    "stage": "Stage",
    "stage_version": "Stage Version",
    "staged_version_is_live_for": "Staged Version is live for",
    "staged_version_to_be_deployed": "Staged Version to be Deployed",
    "standby": "Standby",
    "standing": "Standing",
    "standing_and_transcripts": "standing & transcripts",
    "standing_transcript": "Standings & Transcript",
    "start_after": "Start After",
    "start_date": "Start Date",
    "start_date_must_be_after_todays_date": "Start Date Must be after today's date",
    "start_day": "Start Day",
    "start_import": "Start Import",
    "start_migration": "Start Migration",
    "start_time": "Start Time",
    "start_time_must_be_at_least_2_minutes_from_the_current_time_(utc)_being": "Start Time Must be at least 2 minutes from the current time (UTC) being",
    "started": "Started",
    "starting_import": "Starting Import",
    "state": "State",
    "status": "Status ",
    "step_1": "Step 1",
    "step_2": "Step 2",
    "step_3": "Step 3",
    "student": "Student",
    "student_comments": "Student Comments",
    "student_id": "STUDENT ID",
    "student_name": "Student Name",
    "student_removal_header": "The User Removal Request page allows you to completely delete a student's details. After deleting the student's data, all course and submission data for the student will no longer be available.          Deleted students will sit in a \"Pending Removal\" state for 60 days before being permanently deleted. You may restore these students durring that time. Once deleted, you will not be able to access any archived data for the student and no backups will be maintained.",
    "student_status": "Student Status",
    "students": "Students",
    "students_and_faculty": "Students and Faculty",
    "styling": "Styling",
    "styling_previews": "Styling Previews",
    "sub_account_id": "Sub Account ID",
    "subject": "Subject",
    "submission": "Submission",
    "submission_attempt": "Submission Attempt",
    "submission_comments": "Submission Comments",
    "submission_files": "Submission Files",
    "submission_files_by_student": "Submission Files by Student",
    "submission_information": "Submission Information",
    "submission_title": "Submission Title",
    "submission_type": "Submission Type",
    "submission_url": "Submission URL",
    "submissions": "Submissions",
    "submit": "Submit",
    "submit_username": "Submit Username",
    "subscription_key": "Subscription Key",
    "succesfully_created_identity_provider._it_may_take_around_5_minutes_until_you_are_able_to_see_sso_updates.": "Succesfully Created Identity Provider. It may take around 5 minutes until you are able to see SSO updates.",
    "succesfully_removed_identity_provider._it_may_take_around_5_minutes_until_you_are_able_to_see_sso_updates.": "Succesfully Removed Identity Provider. It may take around 5 minutes until you are able to see SSO updates.",
    "succesfully_updated_identity_provider._it_may_take_around_5_minutes_until_you_are_able_to_see_sso_updates.": "Succesfully Updated Identity Provider. It may take around 5 minutes until you are able to see SSO updates.",
    "success": "Success",
    "successful_deployment": "Successful Deployment",
    "successfully_deleted": "Successfully Deleted",
    "successfully_sent_message": "Successfully Sent Message",
    "successfully_verified_for_mfa_with_authenticator_app": "Successfully Verified for MFA with Authenticator App",
    "suffix": "Suffix",
    "summer": "summer",
    "sunday": "Sunday",
    "supported_file_types_lingo": "Supported file types: .png, .jpg, .gif .svg",
    "survery_results": "Survey Results",
    "survey": "Survey",
    "syllabus": "Syllabus",
    "symbols": "Symbols",
    "sync_to_lms": "Sync To LMS",
    "syncing": "Syncing",
    "syncing_failed": "Syncing Failed",
    "system": "System",
    "systems": "Systems",
    "table": "table",
    "tableau_error": "Your tableau view is not yet ready. Please reach out for any help",
    "tableau_third_party_error": "Go to your browser's settings and enable cookies as well as cross-site cookies or third-party cookies, in order to view the Tableau Dashboard",
    "tags": "Tags",
    "target": "Target",
    "target_only": "Target Only",
    "temp_email_description": "This section will provide the subject and body of the email generated for new users. It must contain",
    "temporary_password_information": "This section is for new users whose temporary password has expired. Instead     of creating a new account it is recommended to refresh their temporary     password. They will receive an email with their temporary password",
    "term": "Term",
    "term_id": "Term ID",
    "term_name": "Term Name",
    "term_sis_id": "Term SIS ID",
    "terms": "Terms",
    "terms_details": "Terms Details",
    "terms_to_import": "Terms to Import",
    "terms_will_populate_upon_integration_being_saved_admin_integration_lingo": "Terms will populate upon integration being saved. This could take up to an       hour to populate.",
    "test": "Test",
    "testing": "Testing",
    "text": "Text",
    "text_contains_answer": "text contains answer",
    "text_link": "Text Link",
    "text_link_color": "Text Link Color",
    "text_link_color_descriptions": "This controls text links and clickable icons. Brand color not recommended",
    "text_match": "text match",
    "text_message": "Text Message",
    "text_only": "Text (No Question)",
    "the_configuration_could_not_be_updated": "The configuration could not be updated",
    "the_configuration_has_been_updated": "The configuration has been updated",
    "the_date_this_version_went_live": "The Date this Version went Live",
    "the_entity_version_is_currently_being_staged_for_deployment": "The entity version is currently being staged for deployment",
    "the_entity_version_is_currently_being_staged_for_deployment._it_will_deploy_once_staged._you_do_not_have_to_stay_on_this_page_in_order_for_the_staging_to_complete.": "The entity version is currently being staged for deployment. It will deploy once staged. You do not have to stay on this page in order for the staging to complete.",
    "the_entity_version_is_currently_being_staged_for_deployment._you_do_not_have_to_stay_on_this_page_in_order_for_the_staging_to_complete.": "The entity version is currently being staged for deployment. You do not have to stay on this page in order for the staging to complete.",
    "the_greeting_message_for_new_users_has_been_updated": "The greeting message for new users has been updated",
    "the_point_value_that_will_be_assigned_to_each_question": "The point value that will be assigned to each question",
    "the_schedule_does_not_allow_for_any_exports_before_the_end_date": "The schedule does not allow for any exports before the end date",
    "the_schedule_does_not_allow_for_any_snapshots_before_the_end_date": "The schedule does not allow for any snapshots before the end date",
    "the_specified_value_was_not_found_in_the_xml": "The specified value was not found in the XML",
    "the_theme_has_been_updated_lingo": "The theme has been updated. It will take a few minutes for the updates to be reflected.",
    "the_user_should_now_be_able_to_sign_in_using_the_temporary_password_granted_to_them": "The user should now be able to sign in using the temporary password granted to them",
    "there_are_no_results_to_export": "There are no results to export",
    "there_is_a_more_recent_draft_of_this": "There is a more recent draft of this",
    "there_is_an_error_in_the_input_lingo": "There is an error in the input, please correct to allow saving",
    "there_may_be_unsaved_changes_in_this_view_lingo": "There may be unsaved changes in this view. Would you like to save?",
    "there_was_an_issue_creating_a_new": "There was an issue creating a new",
    "third": "Third",
    "this_document_provides_a_description_of_the_technical_and_organizational_security_controls": "This document provides a description of the technical and organizational security controls implemented by K16 Solutions.",
    "this_folder": "this folder",
    "this_integration_has_been_deleted": "This integration has been deleted",
    "this_is_a_breaking_change": "This is a breaking change",
    "this_may_take_a_few_minutes": "This may take a few minutes",
    "this_module_will_cover_the_following_topics": "This module will cover the following topics",
    "this_module_will_use_the_following_objectives": "This module will use the following objectives",
    "this_module_will_use_the_following_resources": "This module will use the following resources",
    "this_must_be_added_to_your_identity_provider's_relay_state_in_order_for_logins_to_work_directly_from_your_identity_provider": "This must be added to your identity provider's Relay State in order for logins to work directly from your identity provider",
    "this_section_will_provide_the_subject_and_body_of_the_email_generated_for_new_users.": "This section will provide the subject and body of the email generated for new users.",
    "this_url_must_be_added_to_your_identity_provider's_allowed_callback_urls_lingo": "This URL must be added to your identity provider's Allowed Callback URLs or Sign-in Redirect URIs in order for SSO to work as expected.",
    "this_url_must_be_added_to_your_identity_provider_single_logout_url_in_order_for_slo_to_work_as_expected": "This URL must be added to your identity provider's single logout URL in order for SLO to work as expected.",
    "this_user_now_has_access_to_this_scaffold_instance": "This user now has access to this scaffold instance",
    "this_will_allow_courses_that_are_currently_queued_to_continue_to_be_processed.": "This will allow courses that are currently queued to continue to be processed.",
    "this_will_create_a_draft_version._it_will_not_be_staged_or_be_deployed_after_creation": "This will create a draft version. It will not be staged or be deployed after creation",
    "this_will_create_a_draft_version._it_will_not_be_staged_or_deployed_after_creation": "This will create a draft version. It will not be staged or deployed after creation",
    "this_will_create_a_published_version_and_deploy_it": "This will create a published version and deploy it",
    "this_will_create_a_published_version_and_then_stage_it.": "This will create a published version and then stage it.",
    "this_will_import_the_root_configuration_for_the_scaffold_type_set_in_this_instance": "This will import the root configuration for the Scaffold type set in this instance. Performing this action will overwrite any existing configuration currently in place. This action cannot be undone or restored.",
    "this_will_stop_queued_courses_from_being_processed_any_further.": "This will stop queued courses from being processed any further.",
    "thread_count": "thread count",
    "thursday": "Thursday",
    "till": "Till",
    "time_format": "Time Format",
    "time_limit": "Time Limit",
    "time_on_task": "Time on Task",
    "time_value": "Length of Time",
    "times": "times",
    "timestamp_format": "Timestamp Format",
    "title": "Title",
    "to": "to",
    "to_be_determined": "To Be Determined",
    "to_be_downloaded": "To be Downloaded",
    "to_confirm_deletion,_type_the_name_of_the_blueprint_into_the_box_below": "To confirm deletion, type the name of the blueprint into the box below",
    "to_display": "to display",
    "toggle_version_panel": "Toggle Version Panel",
    "token_url_where_the_application_can_exchange_an_authorization_code_for_an_id_token": "Token URL where the application can exchange an authorization code for an ID token",
    "tokens": "Tokens",
    "too_many_attempts_at_this_time": "Too many attempts at this time",
    "too_many_attempts_made_at_this_time._please_try_again_later": "Too many attempts made at this time. Please try again later",
    "tools": "Tools",
    "top_level_folders_to_modules": "Top Level Folders to Modules",
    "topics": "Topics",
    "total_courses": "Total Courses",
    "total_courses_attempted": "Total Courses Attempted",
    "total_points": "Total Points",
    "total_possible_points": "Total Possible Points",
    "transcript": "transcript",
    "transfer_gpa_hours": "transfer gpa hours",
    "transferred_earned_hours": "transferred earned hours",
    "transferred_gpa": "transferred gpa",
    "transferred_gpa_hours": "transferred GPA hours",
    "transferred_passed_hours": "transferred passed hours",
    "treat_empty_fields_as_null": "Treat empty fields as NULL",
    "trim_whitespace_from_fields": "Trim whitespace from fields",
    "true_false": "True/False",
    "true_feedback": "True Feedback",
    "trust_portal": "Trust Portal",
    "tuesday": "Tuesday",
    "turnitin": "TurnItIn",
    "type": "Type",
    "type_of_change": "Type of Change",
    "type_username_to_refresh": "Type Username to Refresh",
    "uknown_error": "Uknown Error",
    "unable_to_find": "Unable to find",
    "unable_to_find_a_course_with_that_id": "Unable to find a course with that id",
    "unable_to_find_user": "Unable To Find User",
    "unable_to_set_cogntio_domain_at_this_time._unfortunatly_this_is_required_for_sso._please_contact_us_to_try_and_help_resolve_this_issue_if_this_continues.": "Unable to set Cogntio Domain at this time. Unfortunatly this is required       for SSO. Please contact us to try and help resolve this issue if this continues.",
    "unable_to_update_greeting_email_for_new_users_at_this_time": "Unable to Update Greeting Email for New Users at this Time",
    "unable_to_update_the_new_user_email_at_this_time_lingo": "Unable to update the new user email at this time. If this issue persists, please contact an administrator",
    "unassigned": "Unassigned",
    "undefined": "Undefined",
    "unknown_error": "Unknown Error",
    "unknown_error_getting_verification_code": "Unknown error getting verification code",
    "unknown_error_updating_for_mfa_with_authenticator_app_preference": "Unknown Error Updating for MFA with Authenticator App Preference",
    "unknown_error._unable_to_view_tableau_dashboard.": "Unknown error. Unable to View Tableau Dashboard.",
    "unlimited": "Unlimited",
    "unlock": "unlock",
    "unlock_date": "Unlock Date",
    "unpublished_assignment": "Unpublished Assignment",
    "unpublished_discussion": "Unpublished Discussion",
    "unpublished_exam": "Unpublished Exam",
    "unpublished_external_tool": "Unpublished External Tool",
    "unpublished_external_url": "Unpublished External URL",
    "unpublished_file": "Unpublished File",
    "unpublished_forum": "Unpublished Forum",
    "unpublished_page": "Unpublished Page",
    "unsaved_changes": "Unsaved Changes",
    "unselected": "Unselected",
    "unverified_email": "Unverified Email",
    "update": "Update",
    "update_available": "Update Available",
    "update_children": "Update Children",
    "update_integration": "Update Integration",
    "update_schedule": "Update Schedule",
    "update_theme": "Update Theme",
    "update_theme_from_logo": "Update Theme From Logo",
    "update_version": "Update Version",
    "updated": "Updated",
    "updated_by": "Updated By",
    "updated_integration": "Updated Integration",
    "updated_integration._getting_tokens_and_terms": "Updated Integration. Getting Tokens and Terms",
    "updated_schedule": "Updated Schedule",
    "updated_theme._may_have_to_wait_a_few_minutes_after_refreshing_to_see_update": "Updated Theme. May have to wait a few minutes after refreshing to see update",
    "updated_user": "Updated User",
    "updated_with_selected_terms": "Updated With Selected Terms",
    "updates_enabled": "Updates Notifications",
    "updates_enabled_description": "Update Notifications are used for notes on larger system updates",
    "updating_import": "Updating Import",
    "upgrade_available": "Upgrade Available",
    "upload": "Upload",
    "upload_a_logo_here_wizard_lingo": "Update your institution’s logo and color theme here. You can use the preview that is provided as a guide. Once you are satisfied with the theme, click the Update Theme link at the bottom of this step.",
    "upload_complete_click_to_hide": "Upload Complete, Click to Hide",
    "upload_csv_files_containing_your_data_here_to_then_be_able_to_scan_them._ensure_the_first_row_in_each_file_aligns_with_the_expected_field_name_for_your_table.": "Upload CSV files containing your data here to then be able to scan them. Ensure the first row in each file aligns with the expected field name for your table.",
    "upload_files": "Upload Files",
    "upload_import": "Upload Import",
    "upload_logo": "Upload Logo",
    "upload_new_xml_metadata": "Upload New XML Metadata",
    "upload_the_xml_metadata_file_from_your_saml_identity_provider_here._this_should_include_the_issuer_information,_x.509_certificate,_the_sso_service_endpoints,_and_the_email_address_attribute": "Upload the XML metadata file from your SAML identity provider here. This should include the issuer information, X.509 certificate, the SSO service endpoints, and the email address attribute",
    "upload_xml_directly_rather_than_providing_the_url_metadata": "Upload XML directly rather than providing the url metadata",
    "uploaded": "Uploaded",
    "uploading": "Uploading",
    "uppercase": "Uppercase",
    "upstream": "Upstream",
    "url": "URL",
    "url_is_invalid": "Url is invalid",
    "url_to_obtain_additional_user_attributes_or_information": "URL to obtain additional user attributes or information",
    "url_to_obtain_the_json_web_key_set_for_token_verification": "URL to obtain the JSON Web Key Set for token verification",
    "use_assignment_group_weights": "Use Assignment Group Weights",
    "use_existing_assignment": "Use Existing Assignment",
    "use_existing_discussion": "Use Existing Discussion",
    "use_existing_page": "Use Existing Page",
    "use_existing_quiz": "Use Existing Quiz",
    "use_module_descriptions": "Use Module Descriptions",
    "use_selected": "Use Selected",
    "use_the_csv_template_provided_here": "Use the csv template provided here",
    "use_this_column_to_communicate_lingo": "Use this column to communicate any questions/concerns/general notes about the module, including next steps for the module activities.",
    "user": "User",
    "user_accounts": "User Accounts",
    "user_data_management": "User Data Management",
    "user_data_management_description": "Grants access to the User Data Management, which allows users to Hard Delete archived data in the institutions archived instance.",
    "user_data_retention": "User Data Retention",
    "user_data_retention_page_top_lingo": "The User Data Retention page allows you to completely delete a student's details. After deleting the student's data, all course and submission data for the student will no longer be available. Deleted students will sit in a \"Pending Removal\" state for 60 days before being permanently deleted. You may restore these students during that time. Once deleted, you will not be able to access any archived data for the student and no backups will be maintained.",
    "user_details": "User Details",
    "user_emails": "User Emails",
    "user_filter": "User Filter",
    "user_id": "User ID",
    "user_key": "User Key",
    "user_menu": "User Menu",
    "user_role": "User Role",
    "user_settings": "User Settings",
    "username": "Username",
    "username_tooltip": "The username for the account in the system the integration is connected to",
    "users": "Users",
    "users_and_role_permission": "Users & Roles Permission",
    "users_and_roles": "Users & Roles",
    "utility_account": "Utility Account",
    "utility_account_password": "Utility Account Password",
    "utility_account_username": "Utility Account Username",
    "utility_account_wizard_account": "Utility Account: should have root account access, with the proper permissions set to access courses and terms, non-sso, and has accepted the Canvas user agreement.",
    "utility_connection": "Utility Connection",
    "valid": "Valid",
    "values_that_should_be_treated_as_null_in_csv": "Values that should be treated as null in csv",
    "variable_definitions": "Variable Definitions",
    "variables": "Variables",
    "verb": "Verb",
    "verification_check_email": "Please check your email for a verification code",
    "verification_check_phone": "Please check your phone for a verification code",
    "verification_check_phone_tooltip": "Optional. Can be added for account recovery option",
    "verification_code": "Verification Code",
    "verification_code_sent": "Verification code should have been sent via",
    "verification_contact_information": "Verify Contact Information",
    "verification_contact_information_additional": "Verify your contact information, which will be used to reset your password if you are ever locked out.",
    "verified": "Verified",
    "verify": "Verify",
    "verify_account": "Verify Account",
    "version": "Version",
    "version_create": "Version Create",
    "version_details": "Version Details",
    "version_difference_summary": "Version Difference Summary",
    "version_is_staged_&_ready_to_deploy": "Version is Staged & Ready to Deploy",
    "version_log": "Version Log",
    "version_name": "Version Name",
    "version_new": "New Version",
    "version_return_to_create": "Return to Current",
    "version_update_status": "Version Update Status",
    "versions": "Versions",
    "versions_control": "Versions Control",
    "view": "View",
    "view_admin_settings": "View Admin Settings",
    "view_course": "View Course",
    "view_details_chart": "View Details Chart",
    "view_explore": "View Explore",
    "view_explorer": "View Explorer",
    "view_integrations": "View Integrations",
    "view_integrations_definition": "Grants access to view integrations.",
    "view_lineage": "View Lineage",
    "view_more_integrations": "View More Integrations",
    "view_relationships": "View Relationships",
    "view_reporting": "View Reporting",
    "view_reporting_definition": "Provides users will access to view reports.",
    "view_reports_required": "*Requires View Reports permission.",
    "view_sample_rows": "View Sample Rows",
    "view_sso": "View SSO",
    "view_sso_definition": "Access to view Single Sign On.",
    "view_workbook": "View Workbook",
    "we_are_currently_experiencing_more_activity_than_usual": "We are currently experiencing more activity than usual",
    "wednesday": "Wednesday",
    "weekly": "Weekly",
    "weight": "Weight",
    "weighted": "Weighted",
    "weighted_average": "weighted average",
    "which_overall_grade_to_use": "Which Overall Grade To Use",
    "with_error_margin": "With Error Margin",
    "with_precision": "With Precision",
    "wizard": "Wizard",
    "wizard_terms_explanation": "Select the terms you wish to import below, then click the Save Selected Terms link. This will start the process of importing the terms and the associated courses.",
    "word_bank": "word bank",
    "workbook": "Workbook",
    "workbook_must_have_a_unique_name_within_the_selected_workbook": "Workbook must have a unique name within the selected workbook",
    "workflow_state": "Workflow State",
    "worksheet_access": "Worksheet Access",
    "worksheets": "Worksheets",
    "would_you_like_to_save_your_draft_and_leave_the_page_or_save_and_continue_editing": "Would you like to save your draft and leave the page or save and continue editing",
    "would_you_still_like_to_publish_and_stage_this_version": "Would you still like to publish and stage this version",
    "wroksheet_access_definition": "Access to Worksheets found in Analytics. Provides users with access to write and run query sql.",
    "xml_configuration": "XML Configuration",
    "yearly": "Yearly",
    "years": "Years",
    "yes": "Yes",
    "yet_to_be_published": "Yet to be Published",
    "you_can_still_login_directly_with_your_scaffold_username_and_password_here_at": "You can still login directly with your Scaffold username and password here at",
    "you_do_not_have_permission_to_edit_this_integration": "You do not have permission to edit this Integration",
    "you_do_not_have_the_proper_permissions_to_create_a_blueprint": "You do not have the proper permissions to create a Blueprint",
    "you_have_been_logged_out_of_scaffold": "You have been logged out of Scaffold",
    "you_have_not_imported_anything_yet": "You have not imported anything yet",
    "you_may_close_this_modal_now,_or_setup_an_additional_mfa_method": "You may close this modal now, or setup an additional MFA method",
    "your_blueprint_draft_has_been_saved_successfully": "Your Blueprint Draft has been saved successfully",
    "your_file_is_preparing_to_download": "Your File is Preparing to Download",
    "your_temporary_password_for_scaffold": "Your temporary password for Scaffold",
    "zip": "Zip",
    "zip_folder": "Zip Folder",
    "access_to_ai_detection": "Access to AI Detection",
    "access_to_analytics": "Access to Analytics",
    "access_to_archive_v2": "Archiving",
    "access_to_archive_v2_no_self_service": "Archive",
    "access_to_courses": "Access to Courses",
    "access_to_create_edit_and_delete_integrations": "Provides users the ability to create and manage integrations.",
    "access_to_create_edit_and_delete_reports": "Provides users the ability to create and manage reports. ",
    "access_to_create_edit_and_delete_single_sign_on": "Provides users the ability to create and manage Single Sign On.",
    "access_to_create_new_roles_and_edit_permissions_in_a_role": "Provides users the ability to create and manage role permissions.",
    "access_to_datax": "Access to DataX",
    "access_to_datax_alerts": "Access to Alerts",
    "access_to_documentation": "Access to Documentation",
    "access_to_imports": "Access to Imports",
    "access_to_lakehouse": "Access to Lakehouse",
    "access_to_people": "Access to People",
    "access_to_sis_archive": "Access to SIS Archive",
    "access_to_users_roles_page_allowing_creating_editing_and_deleting_user_accounts": "Access to the Users & Roles page allowing creating, editing, and deleting user accounts. Users will have read-only access to view roles and their associated permissions.",
    "access_to_view_single_sign_on": "Access to view Single Sign On.",
    "access_to_worksheets_found_in_analytics_provides_users_with_access_to_write_and_run_query_sql": "Access to Worksheets found in Analytics. Provides users with access to write and run query sql.",
    "account_id": "Account ID",
    "active_terms": "Active Terms",
    "address_phonenumber": "address & phone number",
    "admin_settings_permission_is_required": "Admin Settings permission is required.",
    "admin_settings_permission_required": "Admin Settings permission required.",
    "admin_settings_view_integrations_and_access_to_imports_permission_required": "Admin Settings, View Integrations, and Access to Imports permission required.",
    "ai_detection_dashboard": "AI Detection Dashboard",
    "ai_detection_report": "AI Detection Report",
    "allows_users_access_to_initiate_pause_and_abort_imports": "Allow Users Access to Initiate Pause and Abort Imports",
    "allows_users_to_create_modify_and_delete_export_schedules": "Provides access to create and manage Export Schedules.",
    "allows_users_to_create_modify_and_delete_snapshots_and_snapshot_schedules": "Provides access to create and manage Snapshots and Snapshot Schedules.",
    "allows_users_to_import_data_to_create_data_entities": "Allows users to import data to create data entities.",
    "allows_users_to_restore_soft_deleted_courses_in_the_lms": "Provides users the ability to restore soft deleted courses in the LMS.",
    "allows_users_to_sync_courses_to_the_lms": "Allows users to sync courses to the LMS.",
    "allows_users_to_view_course_data_only": "Provides read only access in courses. This will prevent users from being able to export out course specific data.",
    "amount": "amount",
    "anonymous_survey": "Anonymous Survey",
    "archive_import": "Package Import",
    "archive_import_course_imports": "Extracted Archives",
    "archive_import_description": "Upload a Blackboard course package to initiate extracting and importing the course content (maximum file size: 1 GB).",
    "archive_import_description_html": "<p>Upload a Blackboard course package to initiate extracting and importing the course content (maximum file size: 10 GB). For detailed instructions, see the&nbsp;<a href=\"https://help.k16solutions.com/en/articles/13763166-import-package\" target=\"_blank\" rel=\"noopener noreferrer\" data-sk=\"tooltip_parent\">Import Package help desk article</a>.&nbsp;</p>",
    "archive_import_heading": "Blackboard Course Package Import",
    "archiving": "Archiving",
    "authorized_integrations_only": "Authorized Integrations Only",
    "autocomplete": "Autocomplete",
    "can_not_enable_passkeys_with_mfa_enabled": "Can not enable passkeys with MFA enabled",
    "check_number": "check number",
    "column_constraints": "Column Constraints",
    "courses_currently_being_imported": "Courses currently being imported",
    "courses_failed_to_import._k16_notified_and_investigating": "Courses failed to import. K16 notified and investigating",
    "courses_previously_imported": "Courses previously imported",
    "courses_successfully_imported": "Courses successfully imported",
    "courses_waiting_to_be_imported": "Courses waiting to be imported",
    "data_access": "Data Access",
    "datax_alerts": "DataX Alerts",
    "datax_analytics": "DataX Analytics",
    "datax_documentation": "DataX Documentation",
    "datax_lakehouse": "DataX Lakehouse",
    "deleted_blueprint": "Deleted Blueprint",
    "deleted_import": "Deleted Import",
    "displayed_grade_label": "Show displayed grade",
    "display_grade": "Display Grade",
    "display_grade_header": "Display Grade",
    "does_not_match": "Does Not Match",
    "does_not_meet_minimum_length": "Does Not Meet Minimum Length",
    "do_you_want_to_create_a_passkey_to_login_with_in_the_future?": "Do you want to create a passkey to login with in the future?",
    "duplicate_name": "Duplicate Name",
    "edit_role": "Edit Role",
    "edit_user": "Edit User",
    "enable_restore": "Enable Restore",
    "enable_syncing": "Enable Syncing",
    "enroll_in_course": "Enroll in Course",
    "first_name": "First Name",
    "grants_access_to_ai_detection_features": "Provides access to AI Detection features. This permission is required for all AI Detection features.",
    "grants_access_to_analytic_features": "Grants access to the Analytics navigation menu.  This permission is required for all Analytics features; additional permissions control access to specific features.",
    "grants_access_to_archive_v2_features": "Provides access to Self Service Archiving features.  This permission is required for all Archiving features; additional permissions are required for corresponding features.",
    "grants_access_to_archive_v2_features_no_self_service": "Provides access to Archive features. This permission is required for all Archive features; additional permissions are required for corresponding features.",
    "grants_access_to_datax_alerts": "The Alerts permission grants users access to view and use the Alerts feature within the application.",
    "grants_access_to_datax_features": "Provides access to DataX features. This permission is required for all DataX features; additional permissions are required for corresponding features.",
    "grants_access_to_manage_data_retention_rules_for_your_institution": "Provides users access to manage Data Retention rules for your institution.",
    "grants_access_to_people_features": "Grants access to the People navigation menu and features. Users will be able to view archived account details.",
    "grants_access_to_sis_archive_features": "Provides access to SIS Archive features. This permission is required for all SIS features; additional permissions are required for corresponding features.",
    "grants_access_to_sis_document_features": "Provides access to SIS Documentation.",
    "grants_access_to_sis_finance_features": "Provides access to SIS Finance Data.",
    "grants_access_to_sis_financial_aid_features": "Provides access to SIS Financial Aid Data.",
    "grants_access_to_sis_hr_features": "Provides access to SIS HR Data.",
    "grants_access_to_sis_student_features": "Provides access to SIS Student Data.",
    "grants_access_to_the_courses_page": "Grants access to the Courses page in the navigation menu. This permission is required for all Course features; additional permissions control access to specific features.",
    "grants_access_to_the_import_page": "Grants Access to the import page",
    "grants_access_to_user_data_management_which_allows_users_to_hard_delete_archived_data": "Provides users access to User Data management, which allows users to Hard Delete archived data in the institutions archived instance.",
    "grants_access_to_view_integrations": "Allows user to view integrations. This permissions is needed for specific features throughout the application.",
    "grants_users_ability_to_create_and_edit_blueprints": "Provides users the abilitiy to create and edit Blueprints, as well as update to the latest versions of K16-provided Blueprints and Data Models.",
    "grants_users_access_to_admin_page": "Grants access to the Admin navigation menu and features. Users can access features such as Account Policies and Institution Styling. This permission is required for all Admin features; additional permissions control access to specific Admin features.",
    "grants_users_access_to_create_and_manage_business_glossary_terms": "Provides users access to create and manage Business Glossary Terms.",
    "grants_users_access_to_documentation_features_in_datax": "Grants access to the Documentation navigation menu and features. Users can view features, such as the Business Glossary, Catalog, and entity graphs.  This permission is required for all Documentation features.",
    "grants_users_access_to_lakehouse_features": "Grants users access to the Lakehouse navigation menu and features. Users can view features, such as Deployments and Snapshots.  This permission is required for Lakehouse features; additional permissions control access to specific features.",
    "if_enabled,_users_will_have_read_only_access_and_no_edit_permissions_throughout_scaffold": "If enabled, users will have read only access and no edit permissions throughout Scaffold",
    "import_data_management": "Import Management",
    "import_management": "Import Management",
    "import_of_courses_cancelled": "Import of courses cancelled",
    "in_order_to_access_a_course_users_must_be_enrolled_in_the_course": "Limits users access to courses they are enrolled in. Enrolled courses can be assigned within the User's Account details (or the course).",
    "invalid_password": "Invalid Password",
    "invoice": "invoice",
    "last_name": "Last Name",
    "levenshtein_distance": "levenshtein distance",
    "light_theme_logo": "Light Theme Logo",
    "limits_users_access_to_authorized_integrations_only": "Limits the users access to authorized integrations only. Authorized integrations are assigned in the User's Account details.",
    "lowest_scores": "Lowest Scores",
    "manage_data_retention": "Manage Data Retention",
    "manage_integrations": "Manage Integrations",
    "manage_sso": "Manage SSO",
    "mfa_required": "MFA Required",
    "must_contain_a_number": "Must Contain A Number",
    "musthavelowercase": "Must Have Lowercase Character",
    "musthavespecialcharacter": "Must have a Special Character",
    "musthaveupercase": "Must Have Uppercase",
    "name_middle": "middle name",
    "never_drop": "Never Drop",
    "new_passkey": "New Passkey",
    "no_mpn_loans_to_display": "No MPN Loans to Display.",
    "non_person_name": "non person name",
    "no_terms_found": "No Terms Found",
    "number_of_scores_to_drop": "Number of scores to ignore for each student",
    "ouriginal": "ouriginal enabled",
    "passkeys": "Passkeys",
    "passkey_setup": "Passkey Setup",
    "passkeys_provide_a_more_secure_way_to_sign_in_without_using_a_password._they_use_biometrics_or_a_security_key._if_mfa_is_enabled,_unable_to_login_with_passkeys.": "Passkeys provide a more secure way to sign in without using a password. They use biometrics or a security key. If MFA is enabled, unable to login with passkeys.",
    "passkeys_uses_secure_biometric_to_authenticate_users_using_either_a_fingerprint_or_face_id_passkeys_can_be_used_optionally_rather_than_a_users_password_on_login_if_enabled_it_will_allow_users_to_setup_passkeys_from_their_profile_page_or_when_registering_as_a_new_user": "Passkeys uses secure biometric to authenticate users using either a fingerprint or face id passkeys can be used optionally rather than a user's password on login if enabled it will allow users to setup passkeys from their profile page or when registering as a new user",
    "passkeys_uses_secure_biometric_to_authenticate_users_using_either_a_fingerprint_or_face_id_passkeys_can_be_used_optionally_rather_than_a_users_password_on_login_if_enabled,_it_will_allow_users_to_setup_passkeys_from_their_profile_page_or_when_registering_as_a_new_user": "Passkeys uses secure biometric to authenticate users using either a fingerprint or face id. Passkeys can be used optionally rather than a user's password on login. If enabled, it will allow users to setup passkeys from their profile page or when registering as a new user.",
    "passkeys_uses_secure_biometric_to_authenticate_users_using_either_a_fingerprint_or_face_id._passkeys_can_be_used_optionally_rather_than_a_user's_password_on_login_if_enabled,_it_will_allow_users_to_setup_passkeys_from_their_profile_page_or_when_registering_as_a_new_user": "Passkeys uses secure biometric to authenticate users using either a fingerprint or face id. Passkeys can be used optionally rather than a user's password on login. If enabled, it will allow users to setup passkeys from their profile page or when registering as a new user.",
    "passkeys_uses_secure_biometric_to_authenticate_users_using_either_a_fingerprint_or_face_id._passkeys_can_be_used_optionally_rather_than_a_user's_password_on_login._if_enabled,_it_will_allow_users_to_setup_passkeys_from_their_profile_page_or_when_registering_as_a_new_user.": "Passkeys uses secure biometric to authenticate users using either a     fingerprint or face id. Passkeys can be used optionally rather than a user's     password on login. If enabled, it will allow users to setup passkeys from their profile page or when registering as a new user.",
    "permission_is_required_in_order_to_sync_courses_to_the_lms": "Permission is required in order to sync courses to the LMS.",
    "permissions": "Permissions",
    "product_access": "Product Access",
    "provides_access_to_the_ai_detection_dashboard_and_report": "Provides access to the AI Detection Dashboard and Report.",
    "provides_users_will_access_to_view_reports": "Allows users to have read only access to shared reports within their instance.",
    "read_only": "Read Only",
    "required_permission_is_enabled": "Required permission is enabled",
    "requires": "requires",
    "requires_access_to_analytics_and_datax_permissions": "Requires Access to Analytics and Access to DataX permissions.",
    "requires_access_to_analytics_and_view_reporting_permissions": "Requires Access to Analytics and View Reporting permissions.",
    "requires_access_to_analytics_permission": "Requires Access to Analytics permission.",
    "requires_access_to_analytics_view_reporting_and_datax_permissions": "Requires Access to Analytics, View Reporting, and Access to DataX permissions.",
    "requires_access_to_archivev2": "Requires Access to Archive V2 permission",
    "requires_access_to_courses_permission": "Requires Access to Courses permission.",
    "requires_access_to_datax_permission": "Requires Access to DataX permission.",
    "requires_access_to_documentation_and_datax_permissions": "Requires Access to Documentation and Access",
    "requires_access_to_documentation_permission": "Requires Access to Documentation permission.",
    "requires_access_to_lakehouse_and_datax_permissions": "Requires Access to Lakehouse and Access to DataX permissions.",
    "requires_access_to_lakehouse_permission": "Requires Access to Lakehouse permission.",
    "requires_access_to_people_and_sis_archive_permissions": "Requires Access to People and Access to SIS Archive permissions.",
    "requires_access_to_sis_archive_permission": "Requires Access to SIS Archive permission.",
    "requires_admin_settings_and_access_to_archive_v2_permissions": "Requires Admin Settings and Access to Archive V2 permissions.",
    "requires_admin_settings_and_manage_users_permissions": "Requires Admin Settings and Manage Users permissions.",
    "requires_admin_settings_and_view_integrations_permission": "Requires Admin Settings and View Integrations permission.",
    "requires_admin_settings_and_view_sso_permissions": "Requires Admin Settings and View SSO permissions.",
    "requires_admin_settings_permission": "Requires Admin Settings permission.",
    "requires_view_integrations_permission": "Requires View Integrations Permission.",
    "role_datax_access": "Role Datax Access",
    "search_by_entity": "Search By Entity",
    "search_by_entity_or_column_name": "Search By Entity or Column Name",
    "search_entities_or_constraints": "Search Entities or Constraints",
    "select_role_to_prepopulate": "Select Role to Prepopulate",
    "select_the_course(s)_to_enroll_the_user": "Select the course(s) to enroll the user",
    "sis_document_access": "Document Access",
    "sis_files": "SIS Files",
    "sis_finance_access": "Finance Access",
    "sis_financial_aid_access": "Financial Aid Access",
    "sis_hr_access": "HR Access",
    "sis_student_access": "Student Access",
    "snapshots_management": "Snapshots Management",
    "ssn_tin": "SSN/TIN",
    "step_4": "Step 4",
    "still_requires_at_least_one_of_these_permissions_view_reporting_manage_reports_to_access_this_page": "Still requires at least one of these permissions, View Reporting, Manage Reports, or Manage Reports, to access this page",
    "this_also_provides_access_to_ai_dashboard": "This also provides access to the AI Dashboard.",
    "this_permission_requires_access_to_analytics_to_be_enabled": "This permission requires Access to Analytics to be enabled.",
    "this_permission_requires_access_to_courses_to_be_enabled": "This permission requires Access to Courses to be enabled.",
    "this_permission_requires_access_to_documentation_to_be_enabled": "This permission requires Access to Documentation to be enabled.",
    "this_permission_requires_access_to_lakehouse_to_be_enabled": "This permission requires 'Access to Lakehouse' to be enabled.",
    "this_permission_requires_access_to_sis_archive_to_be_enabled": "This permission requires Access to SIS Archive to be enabled.",
    "this_permission_requires_admin_settings_to_be_enabled": "This permission requires Admin Settings to be enabled.",
    "this_permission_requires_both_admin_settings_and_view_integrations_to_be_enabled": "This permission requires both Admin Settings and View Integrations to be enabled.",
    "this_permission_requires_both_admin_settings_and_view_sso_to_be_enabled": "This permission requires both Admin Settings and View SSO to be enabled.",
    "this_permission_requires_manage_users_to_be_enabled": "This permission requires Manage Users to be enabled.",
    "this_permission_requires_permissions_to_be_enabled": "This permission requires these to be enabled.",
    "this_permission_requires_view_integrations_to_be_enabled": "This permission requires 'View Integrations' to be enabled.",
    "this_permission_requires_view_reporting_to_be_enabled": "This permission requires 'View Reporting' to be enabled.",
    "this_required_permission_must_be_enabled": "This required permission must be enabled",
    "this_url_must_be_added_to_your_identity_provider's_single_logout_url_in_order_for_slo_to_work_as_expected": "This URL must be added to your identity provider's single logout URL in order for SLO to work as expected.",
    "this_url_must_be_added_to_your_identity_provider's_single_logout_url_in_order_for_slo_to_work_as_expected.": "This URL must be added to your identity provider's Single Logout URL in order for SLO to work as expected.",
    "to_access_integration_details_on_admin_and_import_page_admin_settings_permission_must_be_enabled": "To access integration details on the Admin and Import page and initiate an import, Admin Settings permission must be enabled.",
    "to_disable_admin_settings_manage_imports_must_be_disabled": "To disable Admin Settings, Manage Imports must be disabled.",
    "to_disable_admin_settings_manage_integrations_must_be_disabled": "To disable Admin Settings, Manage Integrations must be disabled.",
    "to_disable_admin_settings_view_sso_must_be_disabled": "To disable Admin Settings, View SSO must be disabled.",
    "to_disable_view_integrations_authorized_integrations_only_must_be_disabled": "To disable View Integrations, Authorized Integrations Only must be disabled.",
    "to_disable_view_integrations_manage_imports_must_be_disabled": "To disable View Integrations, Manage Imports must be disabled.",
    "to_disable_view_integrations_manage_integrations_must_be_disabled": "To disable View Integrations, 'Manage Integrations' must be disabled.",
    "to_disable_view_reporting_manage_reports_must_be_disabled": "To disable View Reporting, the permission Manage Reports must be disabled.",
    "to_disable_view_sso_manage_sso_must_be_disabled": "To disable View SSO, Manage SSO must be disabled.",
    "too_many_attempts": "Too many attempts at this time",
    "update_complete": "Update Complete",
    "upload_complete_error": "An error occurred during upload.",
    "upload_complete_starting_import": "Upload complete, starting import for file",
    "use_passkey": "Use Passkey",
    "use_password": "Use Password",
    "user_no_permission_scaffold_instance": "The user doesn't have permission to access this Scaffold instance",
    "vendor_invoice": "vendor invoice",
    "verify_email": "Verify Email",
    "verify_your_email_which_will_be_used_to_reset_your_password_if_you_are_ever_locked_out": "Verify your email, which will be used to reset your password if you are ever locked out.",
    "verify_your_email,_which_will_be_used_to_reset_your_password_if_you_are_ever_locked_out": "Verify your email, which will be used to reset your password if you are ever locked out",
    "year": "year",
    "you_do_not_have_access_to_this_entity": "You do not have access to this entity.",
    "you_do_not_have_the_permission_to_edit_a_role": "You do not have the permission to edit a role",
    "you_must_setup_in_order_to_login": "You must setup in order to login",
    "your_role_has_no_views_found_for_this_product": "Your role has no views found for this product"
}